// // src/pages/DriverDashboard.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   MapContainer,
//   TileLayer,
//   Popup,
//   CircleMarker,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import RecenterButton from "../components/RecenterButton";
// import L from "leaflet";
// import DriverHeader from "../components/DriverHeader";
// import DriverFooter from "../components/DriverFooter";
// import ProfilePictureCropper from "../components/ProfilePictureCropper";
// import UserDetailsOverlay from "../components/UserDetailsOverlay";
// import ActiveBookingsPanel from "../components/ActiveBookingsPanel";
// import HireAssistanceBubble from "../components/HireAssistanceBubble";
// import { useDispatch, useSelector } from "react-redux";
// import BookingAlertOverlay from "../components/BookingAlertOverlay";
// import EmergencyAlertModal from "../components/EmergencyAlertModal";
// import api from "../services/api";
// import { updateEmergency } from "../services/vehicleService";
// import { calculateDistance, estimateETA, calculateFare } from "../services/mapsService";
// import signalrService from "../services/signalr";
// import locationWS from "../services/locationWebSocket";
// import bookingWS from "../services/bookingWebSocket";
// import chatWS from "../services/chatWebSocket";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { getProfilePictureUrl } from "../services/userService";
// import { ChevronLeft, ChevronRight, AlertTriangle } from "lucide-react";
// import { defaultUserImg } from "../assets/defaultUser";
// import { fetchBookings } from "../actions/BookingActions";
// import { fetchUsers } from "../actions/UserActions";
// import { fetchVehicles } from "../actions/VehicleActions";
// import { getBookingDetailsByVehicleId, getForkBookingDetailsAll } from "../services/bookingService";

// // Import vehicle icons
// import carIcon from "../assets/car.png";
// import vanIcon from "../assets/van.png";
// import busIcon from "../assets/bus.png";
// import lorryIcon from "../assets/lorry.png";
// import suvIcon from "../assets/suv.png";
// import cabIcon from "../assets/cab.png";
// import forkliftIcon from "../assets/fork lift.png";
// import dockyardIcon from "../assets/dockyard.png";
// import cherryIcon from "../assets/cherry.png";
// import craneIcon from "../assets/crane.jpg";

// // Fix Leaflet icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

// const AnimatedMapCenter = ({ position }) => {
//   const map = useMap();
//   useEffect(() => {
//     if (position && map && map._container) {
//       try {
//         map.flyTo(position, 16, { animate: true, duration: 1.5 });
//       } catch (err) {
//         console.warn("Map animation error:", err);
//       }
//     }
//   }, [position, map]);
//   return null;
// };

// const DriverDashboard = () => {
//   const dispatch = useDispatch();
//   const { authKey, userDetails } = useSelector((state) => state.auth);
//   const navigate = useNavigate();
//   const [driver, setDriver] = useState({
//     name: "",
//     driverSno: "",
//     vehicleId: "",
//     vehicleType: "",
//     mobileNo: "",
//     profilePic: defaultUserImg,
//     role: "D",
//     status: "A",
//     password: "",
//     file_path: null,
//   });

//   const [currentVehicle, setCurrentVehicle] = useState(null);
//   const [isOnline, setIsOnline] = useState(false);
//   const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
//   const [hasActiveBooking, setHasActiveBooking] = useState(false);

//   const [vehicleLocation, setVehicleLocation] = useState({
//     latitude: 6.95417,
//     longitude: 79.86611,
//   });
//   const [hasLocationFix, setHasLocationFix] = useState(false);

//   const [incomingBooking, setIncomingBooking] = useState(null);
//   const incomingBookingRef = useRef(null);
//   const scheduledShownRef = useRef(new Set());
//   const [isOverlayVisible, setIsOverlayVisible] = useState(false);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [isProfileDetailsVisible, setIsProfileDetailsVisible] = useState(false);
//   const [weatherAlert, setWeatherAlert] = useState("Loading weather...");
//   const [isUploadingPic, setIsUploadingPic] = useState(false);

//   const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
//   const [isSendingEmergency, setIsSendingEmergency] = useState(false);
//   const [isSosExpanded, setIsSosExpanded] = useState(false);
//   const [isUpdatingMobile, setIsUpdatingMobile] = useState(false);
//   const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);
//   const [showCropper, setShowCropper] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const fileInputRef = useRef(null);

//   const [activeHire, setActiveHire] = useState(null);
//   const [hireStage, setHireStage] = useState('accepted');
//   const [pickupLocation, setPickupLocation] = useState(null);
//   const [destinationLocation, setDestinationLocation] = useState(null);

//   const getBookings = async () => dispatch(fetchBookings());
//   const getUsers = async () => dispatch(fetchUsers());
//   const getVehicles = async () => dispatch(fetchVehicles());

//   const locationInterval = useRef(null);

//   const getVehicleIcon = (vehicleType) => {
//     const type = vehicleType?.toUpperCase()?.trim() || "";
//     if (type === "V" || type.includes("VAN")) return vanIcon;
//     if (type === "B" || type.includes("BUS")) return busIcon;
//     if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) return lorryIcon;
//     if (type === "S" || type.includes("SUV")) return suvIcon;
//     if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) return cabIcon;
//     if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) return forkliftIcon;
//     if (type === "CR" || type.includes("CRANE")) return craneIcon;
//     if (type.includes("DOCKYARD")) return dockyardIcon;
//     if (type === "CH" || type.includes("CHERRY")) return cherryIcon;
//     if (type === "C" || type.includes("CAR")) return carIcon;
//     return carIcon;
//   };

//   const mapRole = (r) => {
//     if (!r) return "D";
//     const v = r.toString().trim().toUpperCase();
//     switch (v) {
//       case "S": return "S";
//       case "E": return "E";
//       case "A": return "A";
//       case "EN": return "EN";
//       case "D": return "D";
//       default: return "D";
//     }
//   };

//   const mapStatus = (s) => {
//     const v = s?.toString().trim().toUpperCase();
//     return v === "ACTIVE" || v === "A" ? "A" : "I";
//   };

//   const normalizeVehicleType = (type) => {
//     const t = (type ?? "").toString().trim();
//     const typeCodeMap = {
//       Car: "C", Van: "V", Lorry: "L", SUV: "S", Cab: "CA",
//       Bus: "B", "Cherry Picker": "CH", Forklift: "F", Crane: "CR", Trailer: "T",
//     };
//     if (typeCodeMap[t]) return typeCodeMap[t];
//     if (t.length > 0 && t.length <= 2) return t;
//     return "C";
//   };

//   const normalizeBStatus = (value) => {
//     const v = (value ?? "").toString().trim().toUpperCase();
//     if (!v) return "";
//     if (v.startsWith("P")) return "P";
//     if (v.startsWith("B")) return "B";
//     if (v.startsWith("C")) return "C";
//     return v.length <= 2 ? v : v[0];
//   };

//   const getCurrentLocation = () => {
//     return new Promise((resolve) => {
//       if ("geolocation" in navigator) {
//         navigator.geolocation.getCurrentPosition(
//           (pos) => {
//             const location = {
//               latitude: pos.coords.latitude.toFixed(6),
//               longitude: pos.coords.longitude.toFixed(6),
//             };
//             setHasLocationFix(true);
//             resolve(location);
//           },
//           () => resolve(vehicleLocation),
//           { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 }
//         );
//       } else {
//         resolve(vehicleLocation);
//       }
//     });
//   };

//   const updateVehicleInDB = async (newOStatus = null) => {
//     if (!currentVehicle) return;
//     const location = await getCurrentLocation();
//     const vehicleTypeCode = normalizeVehicleType(currentVehicle.vehicleType || currentVehicle.vehicle_type);
//     const statusCode = currentVehicle.status === "Active" ? "A" :
//       currentVehicle.status === "Inactive" ? "I" :
//         currentVehicle.status || "A";
//     const oStatusValue = newOStatus || (isOnline ? "O" : "F");
//     const bStatusValue = normalizeBStatus(currentVehicle.bStatus);

//     const payload = [{
//       vehicleId: currentVehicle.vehicleId,
//       vehicleType: vehicleTypeCode,
//       weightCat: currentVehicle.weightCat || "",
//       driverSno: currentVehicle.driverSno || "",
//       status: statusCode,
//       bStatus: bStatusValue,
//       oStatus: oStatusValue,
//       latitude: oStatusValue === "F" ? "" : location.latitude,
//       longitude: oStatusValue === "F" ? "" : location.longitude,
//     }];

//     try {
//       await api.post("/VehicleRegister/PostVehicleDetails", payload);
//       setVehicleLocation({
//         latitude: parseFloat(location.latitude),
//         longitude: parseFloat(location.longitude),
//       });
//     } catch (err) {
//       console.error("Failed to save location/status:", err);
//     }
//   };

//   const updateVehicleBookingStatus = async (newBStatus = "B") => {
//     if (!currentVehicle) return;
//     const location = await getCurrentLocation();
//     const vehicleTypeCode = normalizeVehicleType(currentVehicle.vehicleType || currentVehicle.vehicle_type);
//     const statusCode = currentVehicle.status === "Active" ? "A" :
//       currentVehicle.status === "Inactive" ? "I" :
//         currentVehicle.status || "A";
//     const bStatusValue = normalizeBStatus(newBStatus);
//     const oStatusValue = isOnline ? "O" : "F";

//     const payload = [{
//       vehicleId: currentVehicle.vehicleId,
//       vehicleType: vehicleTypeCode,
//       weightCat: currentVehicle.weightCat || "",
//       driverSno: currentVehicle.driverSno || "",
//       status: statusCode,
//       bStatus: bStatusValue,
//       oStatus: oStatusValue,
//       latitude: location.latitude,
//       longitude: location.longitude,
//     }];

//     try {
//       await api.post("/VehicleRegister/PostVehicleDetails", payload);
//       setCurrentVehicle({
//         ...currentVehicle,
//         bStatus: newBStatus,
//       });
//     } catch (err) {
//       console.error("Failed to update vehicle booking status:", err);
//     }
//   };

//   const updateVehicleLocation = async () => {
//     if (!currentVehicle) return;
//     const location = await getCurrentLocation();
//     const statusCode = currentVehicle.status === "Active" ? "A" :
//       currentVehicle.status === "Inactive" ? "I" :
//         currentVehicle.status || "A";

//     const payload = [{
//       vehicleId: currentVehicle.vehicleId,
//       status: statusCode,
//       latitude: location.latitude,
//       longitude: location.longitude,
//     }];

//     try {
//       await api.post("/VehicleRegister/UpdateVehicleLocation", payload);
//       setVehicleLocation({
//         latitude: parseFloat(location.latitude),
//         longitude: parseFloat(location.longitude),
//       });
//     } catch (err) {
//       console.error("Failed to update vehicle location:", err);
//     }
//   };

//   const isActiveBookingStatus = (value) => {
//     const s = String(value || "").trim().toUpperCase();
//     return (
//       s === "A" || s === "ACTIVE" || s === "EN" || s === "ENROUTE" || 
//       s === "IP" || s === "INPROGRESS" || s === "IN PROGRESS"
//     );
//   };

//   const handleOpenEmergency = () => {
//     setIsEmergencyModalOpen(true);
//   };

//   const handleSendEmergency = async ({ ecode, ediscription }) => {
//     if (!driver.vehicleId) {
//       toast.error("No vehicle assigned. Cannot send alert.");
//       return;
//     }

//     setIsSendingEmergency(true);
//     try {
//       let activeBooking = null;
//       if (hasActiveBooking) {
//         try {
//           const allBookings = await getBookings();
//           const driverId = driver.driverSno || userDetails?.ServiceNo;
//           const vehicleId = driver.vehicleId;
//           const activeStatuses = ["A", "ACTIVE", "EN", "ENROUTE", "IP", "INPROGRESS", "IN PROGRESS"];
//           const candidates = allBookings.filter((b) => {
//             const status = (b.status || "").toString().trim().toUpperCase();
//             return (
//               driverId && vehicleId &&
//               b.dSNo?.toString() === driverId.toString() &&
//               b.vId?.toString() === vehicleId.toString() &&
//               activeStatuses.includes(status)
//             );
//           });
//           if (candidates.length > 0) {
//             activeBooking = [...candidates].sort((a, b) => {
//               const aTime = new Date(a.bookingDT || a.bsTime || 0).getTime();
//               const bTime = new Date(b.bookingDT || b.bsTime || 0).getTime();
//               return bTime - aTime;
//             })[0];
//           }
//         } catch (findErr) {
//           console.error("Failed to find active booking for SOS:", findErr);
//         }
//       }

//       await updateEmergency(driver.vehicleId, ecode, ediscription);
//       chatWS.sendEmergency({
//         vehicleId: driver.vehicleId,
//         ecode: ecode,
//         ediscription: ediscription,
//         driverName: driver.name || "Unknown Driver",
//         driverSno: driver.driverSno,
//         mobileNo: driver.mobileNo,
//         ...(activeBooking ? {
//           bId: activeBooking.bId,
//           bookingSno: activeBooking.bookingSno || activeBooking.BookingSno || "",
//           bookingStatus: activeBooking.status,
//         } : {}),
//       });

//       if (!hasActiveBooking && isOnline && currentVehicle) {
//         try {
//           await updateVehicleInDB("F");
//           setIsOnline(false);
//           setCurrentVehicle({ ...currentVehicle, oStatus: "F" });
//           locationWS.disconnect();
//         } catch (statusErr) {
//           console.error("Failed to update vehicle offline status after SOS:", statusErr);
//         }
//       }

//       toast.success("EMERGENCY ALERT SENT! Help is on the way.");
//       setIsEmergencyModalOpen(false);
//     } catch (error) {
//       console.error("Emergency Alert Failed:", error);
//       toast.error("Failed to send alert! Please call emergency services.");
//     } finally {
//       setIsSendingEmergency(false);
//     }
//   };

//   const toggleOnlineStatus = async () => {
//     if (!currentVehicle || isUpdatingStatus) return;
//     const willBeOnline = !isOnline;
//     setIsUpdatingStatus(true);

//     try {
//       if (isOnline && hasActiveBooking) {
//         try {
//           const driverId = String(userDetails?.ServiceNo || "").trim();
//           const vehicleId = String(currentVehicle?.vehicleId || "").trim();
//           const allBookings = await getBookings();
//           const active = (allBookings || []).some((b) => {
//             return (
//               String(b?.dSNo || "").trim() === driverId &&
//               String(b?.vId || "").trim() === vehicleId &&
//               isActiveBookingStatus(b?.status)
//             );
//           });
//           if (active) {
//             toast.error("Cannot go offline during active hire", { position: "top-center", autoClose: 3000 });
//             return;
//           }
//           setHasActiveBooking(false);
//           await updateVehicleBookingStatus("");
//           setCurrentVehicle({ ...currentVehicle, bStatus: "" });
//         } catch (err) {
//           console.error("Failed to re-check active booking:", err);
//           toast.error("Unable to verify booking status. Try again.", { position: "top-center", autoClose: 3000 });
//           return;
//         }
//       }

//       if (willBeOnline) {
//         try {
//           const vehicles = await getVehicles();
//           const driverId = userDetails?.ServiceNo;
//           const assigned = vehicles.find(
//             (v) => (v.vehicleId && currentVehicle.vehicleId && v.vehicleId.toString() === currentVehicle.vehicleId.toString()) ||
//               (driverId && v.driverSno && v.driverSno.toString() === driverId.toString())
//           );
//           const hasActiveSOS = !!(assigned?.ecode && assigned.ecode.toString().trim() !== "");
//           if (hasActiveSOS) {
//             toast.error("You cannot go ONLINE while an emergency alert is active. Please wait until admin resolves it.", { position: "top-center", autoClose: 4000 });
//             return;
//           }
//         } catch (checkErr) {
//           console.error("Failed to verify SOS status before going ONLINE:", checkErr);
//           toast.error("Unable to verify emergency status. Please try again in a moment.", { position: "top-center", autoClose: 4000 });
//           return;
//         }
//       }

//       await updateVehicleInDB(willBeOnline ? "O" : "F");
//       setIsOnline(willBeOnline);
//       setCurrentVehicle({ ...currentVehicle, oStatus: willBeOnline ? "O" : "F" });

//       if (willBeOnline) {
//         const locationData = {
//           vehicleId: currentVehicle.vehicleId,
//           driverSno: currentVehicle.driverSno || userDetails?.ServiceNo,
//           driverName: driver.name,
//           vehicle_type: currentVehicle.vehicleType,
//           latitude: vehicleLocation.latitude,
//           longitude: vehicleLocation.longitude,
//           status: currentVehicle.status || "Active",
//           bStatus: currentVehicle.bStatus || "",
//           oStatus: "O",
//         };
//         locationWS.connect(authKey, locationData);
//       } else {
//         locationWS.disconnect();
//       }

//       toast.success(`You are now ${willBeOnline ? "ONLINE" : "OFFLINE"}!`, { position: "top-center", autoClose: 2500 });
//     } catch (err) {
//       toast.error("Failed to update status. Try again.");
//     } finally {
//       setIsUpdatingStatus(false);
//     }
//   };

//   const fetchDriverAndVehicle = async () => {
//     try {
//       const [users, vehicles] = await Promise.all([getUsers(), getVehicles()]);
//       if (Array.isArray(users)) {
//         const thisDriver = users.find((u) => u.ServiceNo === userDetails.ServiceNo);
//         if (thisDriver) {
//           setDriver((prev) => ({
//             ...prev,
//             name: thisDriver.Name || "Driver",
//             driverSno: thisDriver.ServiceNo,
//             mobileNo: thisDriver.MobileNo || "N/A",
//             profilePic: getProfilePictureUrl(thisDriver.ServiceNo),
//             role: mapRole(thisDriver.role),
//             status: mapStatus(thisDriver.status),
//             password: thisDriver.password || "",
//             file_path: thisDriver.file_path || null,
//           }));
//         }
//       }

//       if (Array.isArray(vehicles)) {
//         const assignedVehicle = vehicles.find((v) => v.driverSno === userDetails.ServiceNo);
//         if (assignedVehicle) {
//           setCurrentVehicle(assignedVehicle);
//           const dbOStatus = (assignedVehicle.oStatus || "").trim();
//           const online = dbOStatus === "O" || dbOStatus === "Online";
//           setIsOnline(online);
//           setDriver((prev) => ({
//             ...prev,
//             vehicleId: assignedVehicle.vehicleId,
//             vehicleType: assignedVehicle.vehicleType || "Unknown",
//           }));

//           const hasValidCoords = assignedVehicle.latitude && assignedVehicle.longitude &&
//             !isNaN(parseFloat(assignedVehicle.latitude)) && !isNaN(parseFloat(assignedVehicle.longitude));

//           if (hasValidCoords) {
//             setVehicleLocation({
//               latitude: parseFloat(assignedVehicle.latitude),
//               longitude: parseFloat(assignedVehicle.longitude),
//             });
//             setHasLocationFix(true);
//           } else {
//             getCurrentLocation().then((liveLocation) => {
//               setVehicleLocation({
//                 latitude: parseFloat(liveLocation.latitude),
//                 longitude: parseFloat(liveLocation.longitude),
//               });
//               setHasLocationFix(true);
//             }).catch(() => {
//               setVehicleLocation({ latitude: 6.9271, longitude: 79.8612 });
//             });
//           }
//         }
//       }
//     } catch (err) {
//       toast.error("Failed to load profile");
//       console.error(err);
//     }
//   };

//   const fetchWeatherAlert = async () => {
//     try {
//       const { latitude, longitude } = vehicleLocation;
//       const weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`;
//       const res = await fetch(weatherUrl);
//       const data = await res.json();
//       const code = data.current_weather?.weathercode;
//       const desc = {
//         0: "Clear sky", 1: "Mainly clear", 2: "Partly cloudy", 3: "Overcast",
//         45: "Fog", 51: "Light drizzle", 61: "Light rain", 63: "Rain", 65: "Heavy rain",
//         71: "Light snow", 80: "Rain showers", 95: "Thunderstorm",
//       }[code] || "Weather info unavailable";
//       setWeatherAlert(desc);
//     } catch {
//       setWeatherAlert("Weather service unavailable");
//     }
//   };

//   const handleProfilePictureChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       toast.error("Please select an image file");
//       return;
//     }
//     if (file.size > 10 * 1024 * 1024) {
//       toast.error("Image size should be less than 10MB");
//       return;
//     }
//     const reader = new FileReader();
//     reader.onload = () => {
//       setSelectedImage(reader.result);
//       setShowCropper(true);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleCropComplete = async (croppedBlob) => {
//     setShowCropper(false);
//     setIsUploadingPic(true);
//     try {
//       const croppedFile = new File([croppedBlob], "profile.jpg", { type: "image/jpeg" });
//       const formData = new FormData();
//       formData.append("ServiceNo", driver.driverSno);
//       formData.append("Name", driver.name);
//       formData.append("MobileNo", driver.mobileNo);
//       formData.append("role", driver.role);
//       formData.append("status", driver.status);
//       formData.append("password", driver.password || "");
//       formData.append("ImageFile", croppedFile);
//       if (driver.file_path) {
//         formData.append("file_path", driver.file_path);
//       }
//       await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
//       const timestamp = Date.now();
//       const newPicUrl = `${getProfilePictureUrl(driver.driverSno)}&t=${timestamp}`;
//       setDriver((prev) => ({ ...prev, profilePic: newPicUrl }));
//       toast.success("Profile picture updated successfully!");
//     } catch (err) {
//       console.error("Failed to upload profile picture:", err);
//       toast.error("Failed to update profile picture");
//     } finally {
//       setIsUploadingPic(false);
//       setSelectedImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = "";
//       }
//     }
//   };

//   const handleCropperClose = () => {
//     setShowCropper(false);
//     setSelectedImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleMobileNumberUpdate = async (newMobileNumber) => {
//     setIsUpdatingMobile(true);
//     try {
//       const formData = new FormData();
//       formData.append("ServiceNo", driver.driverSno);
//       formData.append("Name", driver.name);
//       formData.append("MobileNo", newMobileNumber);
//       formData.append("role", driver.role);
//       formData.append("status", driver.status);
//       formData.append("password", driver.password || "");
//       if (driver.file_path) {
//         formData.append("file_path", driver.file_path);
//       }
//       const response = await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
//       if (response?.data?.statusCode === 200) {
//         setDriver((prev) => ({ ...prev, mobileNo: newMobileNumber }));
//         toast.success("Mobile number updated successfully!");
//         return true;
//       } else {
//         throw new Error(response?.data?.message || "Update failed");
//       }
//     } catch (err) {
//       console.error("Failed to update mobile number:", err);
//       toast.error("Failed to update mobile number");
//       throw err;
//     } finally {
//       setIsUpdatingMobile(false);
//     }
//   };

//   const handlePasswordChange = async (currentPassword, newPassword) => {
//     try {
//       const formData = new FormData();
//       formData.append("ServiceNo", driver.driverSno);
//       formData.append("Name", driver.name);
//       formData.append("MobileNo", driver.mobileNo);
//       formData.append("role", driver.role);
//       formData.append("status", driver.status);
//       formData.append("password", newPassword);
//       if (driver.file_path) {
//         formData.append("file_path", driver.file_path);
//       }
//       const response = await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
//       if (response?.data?.statusCode === 200) {
//         setDriver((prev) => ({ ...prev, password: newPassword }));
//         toast.success("Password changed successfully!");
//         return true;
//       } else {
//         throw new Error(response?.data?.message || "Password change failed");
//       }
//     } catch (err) {
//       console.error("Failed to change password:", err);
//       throw err;
//     }
//   };

//   const updateHireAssistance = (booking) => {
//     if (!booking) return;
//     const pickup = { lat: parseFloat(booking.slatitude), lng: parseFloat(booking.slongitude) };
//     const destination = { lat: parseFloat(booking.elatitude), lng: parseFloat(booking.elongitude) };
//     const distance = calculateDistance(pickup, destination);
//     const eta = estimateETA(distance);
//     const fare = calculateFare(distance);
//     setActiveHire({
//       hireId: booking.bId,
//       bookingId: booking.bId,
//       status: 'accepted',
//       pickupLocation: pickup,
//       destinationLocation: destination,
//       distance: distance,
//       eta: eta,
//       fare: fare,
//     });
//     setHireStage('accepted');
//     setPickupLocation(pickup);
//     setDestinationLocation(destination);
//   };

//   const normalizeBookingStatusCode = (bookingOrValue) => {
//     const raw = bookingOrValue?.BookingStatus ?? bookingOrValue;
//     const v = String(raw || "").trim().toUpperCase();
//     const hasScheduleTimes = Boolean(bookingOrValue?.bsTime && bookingOrValue?.beTime);
//     const isScheduledLabel = v === "S" || v === "SHEDULE BOOKING" || v === "SCHEDULE BOOKING";
//     if (isScheduledLabel) return "S";
//     if (hasScheduleTimes) return "S";
//     return "R";
//   };

//   const normalizeStatus = (value) => String(value || "").trim().toUpperCase();
//   const isPendingStatus = (value) => {
//     const s = normalizeStatus(value);
//     return s === "P" || s === "PENDING" || s === "R";
//   };

//   const isScheduledBookingStatus = (value) => {
//     const v = normalizeStatus(value);
//     return v === "S" || v === "SHEDULE BOOKING" || v === "SCHEDULE BOOKING";
//   };

//   const isScheduledCandidate = (booking) => {
//     if (isScheduledBookingStatus(booking?.BookingStatus)) return true;
//     const bookingDT = parseBookingDateTime(booking?.bookingDT);
//     const bsTime = parseBookingDateTime(booking?.bsTime);
//     if (!bookingDT || !bsTime) return false;
//     return isPendingStatus(booking?.status) && bookingDT.getTime() !== bsTime.getTime();
//   };

//   const parseBookingDateTime = (dateStr) => {
//     if (!dateStr) return null;
//     const direct = new Date(dateStr);
//     if (!isNaN(direct.getTime())) return direct;
//     const parts = String(dateStr).trim().split(" ");
//     if (parts.length >= 2 && parts[0].includes("/")) {
//       const dateParts = parts[0].split("/");
//       if (dateParts.length === 3) {
//         const month = parseInt(dateParts[0], 10);
//         const day = parseInt(dateParts[1], 10);
//         const year = parseInt(dateParts[2], 10);
//         const timePart = parts.slice(1).join(" ");
//         const timeMatch = timePart.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?/i);
//         if (timeMatch) {
//           let hour = parseInt(timeMatch[1], 10);
//           const minute = parseInt(timeMatch[2], 10);
//           const second = parseInt(timeMatch[3] || "0", 10);
//           const ampm = (timeMatch[4] || "").toUpperCase();
//           if (ampm === "PM" && hour < 12) hour += 12;
//           if (ampm === "AM" && hour === 12) hour = 0;
//           return new Date(year, month - 1, day, hour, minute, second);
//         }
//       }
//     }
//     return null;
//   };

//   // Function to fetch reqId from API
//   const fetchReqIdByBookingId = async (bId) => {
//     try {
//       const response = await api.get(`/BookingRegister/GetBookingById/${bId}`);
//       if (response.data && response.data.reqId) {
//         return response.data.reqId;
//       }
//       return null;
//     } catch (err) {
//       console.error("Failed to fetch reqId:", err);
//       return null;
//     }
//   };

//   const handleAcceptBooking = async () => {
//     if (!incomingBooking || isProcessing) return;
//     setIsProcessing(true);

//     try {
//       // Try to get reqId - first from booking, then from API
//       let reqIdValue = incomingBooking.reqId || incomingBooking.ReqId || incomingBooking.requestId || "";
      
//       // If reqId is still empty, fetch it from the API using bId
//       // if (!reqIdValue && incomingBooking.bId) {
//       //   console.log("Fetching reqId from API for booking:", incomingBooking.bId);
//       //   reqIdValue = await fetchReqIdByBookingId(incomingBooking.bId);
//       //   console.log("Fetched reqId:", reqIdValue);
//       // }
      
//       if (!reqIdValue) {
//         console.error("CRITICAL: reqId missing from incoming booking and could not be fetched");
//         toast.error("Cannot accept: Missing booking reference");
//         setIsProcessing(false);
//         return;
//       }

//       updateHireAssistance(incomingBooking);

//       const now = new Date();
//       const isoDate = now.toISOString().slice(0, 10);
//       const timeStr = now.toTimeString().slice(0, 8);
//       const bsTimeFormatted = `${isoDate} ${timeStr}`;

//       const payload = [{ status: "A", bId: incomingBooking.bId }];

//       await api.post("/BookingRegister/PostBookingStatus", payload);

//        const RequestStatuspayload = [{ status: "A", bId: incomingBooking.bId, reqId: reqIdValue  }];

//       await api.post("/BookingRegister/PostBookingRequestStatus", RequestStatuspayload);

//       // Send through all WebSocket channels
//       bookingWS.sendStatusUpdate({
//         bId: parseInt(incomingBooking.bId),
//         reqId: reqIdValue,
//         status: "A",
//         vId: incomingBooking.vId,
//         dSNo: incomingBooking.dSNo,
//         bookingSno: incomingBooking.bookingSno,
//         dlatitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
//         dlongitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
//       });

//       chatWS.sendStatus({
//         bId: incomingBooking.bId,
//         reqId: reqIdValue,
//         status: "A",
//         message: "accepted hire look for my booking for more details",
//         targetUserId: incomingBooking.bookingSno
//       });

//       if (signalrService && signalrService.isConnected) {
//         await signalrService.sendBookingStatusUpdate({
//           bId: parseInt(incomingBooking.bId),
//           reqId: reqIdValue,
//           status: "A",
//           vId: incomingBooking.vId,
//           dSNo: incomingBooking.dSNo,
//           bookingSno: incomingBooking.bookingSno,
//           latitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
//           longitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
//         });
//       }

//       await updateVehicleBookingStatus("B");

//       locationWS.updateDriverData({
//         vehicleId: incomingBooking.vId,
//         vehicle_type: currentVehicle?.vehicleType || "Car",
//         vehicleType: currentVehicle?.vehicleType || "Car",
//         latitude: currentVehicle?.latitude || vehicleLocation.latitude,
//         longitude: currentVehicle?.longitude || vehicleLocation.longitude,
//         bStatus: "B",
//         oStatus: "O",
//         status: "A",
//         reqId: reqIdValue,
//       });

//       if (locationWS.isReady && locationWS.isReady()) {
//         locationWS.sendLocationUpdate();
//       }

//       toast.success("Trip Accepted! Redirecting...", { position: "top-center" });
//       setIsOverlayVisible(false);
//       setIncomingBooking(null);
//       navigate(`/driver-trip/${incomingBooking.bId}`);
      
//     } catch (err) {
//       console.error("Accept failed:", err);
//       toast.error("Failed to accept trip");
//       setIsProcessing(false);
//     }
//   };

// //   const handleAcceptBooking = async () => {
// //   if (!incomingBooking || !incomingBooking.reqId) {
// //     toast.error("No booking selected to accept!");
// //     return;
// //   }

// //   const reqIdValue = incomingBooking.reqId; // ReqId of the booking
// //   const payload = [{
// //      status: "A",
// //      bId: incomingBooking.bId
// //   }];

// //   setIsProcessing(true); // optional: show spinner

// //   try {
// //     // 1️⃣ Send to PostRequestedstatus
// //     const response = await api.post("/BookingRegister/PostBookingStatus", payload);

// //     if (response?.data?.success) {
// //       toast.success("Booking accepted successfully!");

// //       // 2️⃣ Proceed to assign driver or next stage
// //       // Example: call your existing assign function
// //       await assignDriverToBooking(incomingBooking); // <-- your function here

// //       // 3️⃣ Update UI
// //       setIncomingBooking(null); // remove accepted booking from queue
// //       setHasActiveBooking(true);

// //     } else {
// //       toast.error(response?.data?.message || "Failed to accept booking.");
// //     }

// //   } catch (err) {
// //     console.error("Accept booking failed:", err);
// //     toast.error("Error occurred while accepting booking.");
// //   } finally {
// //     setIsProcessing(false);
// //   }
// // };

//   const handleCancelBooking = async () => {
//     if (!incomingBooking || isProcessing) return;
//     setIsProcessing(true);

//     try {
//       let reqIdValue = incomingBooking.reqId || incomingBooking.ReqId || incomingBooking.requestId || "";
      
//       if (!reqIdValue && incomingBooking.bId) {
//         reqIdValue = await fetchReqIdByBookingId(incomingBooking.bId);
//       }

      
//       const payload = [{ status: "C", bId: incomingBooking.bId }];

//       await api.post("/BookingRegister/PostBookingStatus", payload);

//       const RequestStatuspayload = [{ status: "C", bId: incomingBooking.bId, reqId: reqIdValue  }];

//       await api.post("/BookingRegister/PostBookingRequestStatus", RequestStatuspayload);


//       bookingWS.sendStatusUpdate({
//         bId: parseInt(incomingBooking.bId),
//         vId: incomingBooking.vId,
//         reqId: reqIdValue,
//         status: "C",
//         dSNo: incomingBooking.dSNo,
//         bookingSno: incomingBooking.bookingSno,
//         dlatitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
//         dlongitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
//       });

//       chatWS.sendStatus({
//         bId: incomingBooking.bId,
//         reqId: reqIdValue,
//         status: "C",
//         message: "canceled by driver check for another vehicle",
//         targetUserId: incomingBooking.bookingSno
//       });

//       await updateVehicleBookingStatus("");
//       toast.info("Trip declined", { position: "top-center" });
//       setIsOverlayVisible(false);
//       setIncomingBooking(null);
//     } catch (err) {
//       console.error("Decline failed:", err);
//       toast.error("Failed to decline");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   useEffect(() => {
//     if (!authKey) return;
//     fetchDriverAndVehicle();
//     fetchWeatherAlert();
//   }, [authKey]);

//   useEffect(() => {
//     incomingBookingRef.current = incomingBooking;
//   }, [incomingBooking]);

//   useEffect(() => {
//     if (!authKey || !currentVehicle?.vehicleId || !userDetails?.ServiceNo) {
//       setHasActiveBooking(false);
//       return;
//     }

//     let isMounted = true;
//     const pollActiveBooking = async () => {
//       try {
//         const driverId = String(userDetails.ServiceNo || "").trim();
//         const vehicleId = String(currentVehicle.vehicleId || "").trim();
//         const allBookings = await getBookings();
//         const active = (allBookings || []).some((b) => {
//           return (
//             String(b?.dSNo || "").trim() === driverId &&
//             String(b?.vId || "").trim() === vehicleId &&
//             isActiveBookingStatus(b?.status)
//           );
//         });
//         if (isMounted) setHasActiveBooking(active);
//         if (!active && (currentVehicle?.bStatus === "B" || currentVehicle?.bStatus === "Booking")) {
//           await updateVehicleBookingStatus("");
//           if (isMounted) setCurrentVehicle({ ...currentVehicle, bStatus: "" });
//         }
//       } catch (err) {
//         console.error("Failed to sync active booking status:", err);
//       }
//     };
//     pollActiveBooking();
//     const interval = setInterval(pollActiveBooking, 30000);
//     return () => {
//       isMounted = false;
//       clearInterval(interval);
//     };
//   }, [authKey, currentVehicle?.vehicleId, currentVehicle?.bStatus, userDetails?.ServiceNo]);

//   useEffect(() => {
//     if (!isOnline || !authKey || !currentVehicle?.vehicleId || !userDetails?.ServiceNo) return;
//     let isMounted = true;
//     const windowMs = 2 * 60 * 1000;
//     const pollScheduled = async () => {
//       if (!isMounted || isOverlayVisible || isProcessing) return;
//       try {
//         const vehicleId = String(currentVehicle.vehicleId || "").trim();
//         const driverId = String(userDetails.ServiceNo || "").trim();
//         if (!vehicleId || !driverId) return;
//         const bookings = await getBookingDetailsByVehicleId(vehicleId);
//         const now = new Date();
//         const due = (bookings || [])
//           .filter((b) => String(b?.dSNo || "").trim() === driverId)
//           .filter((b) => String(b?.vId || "").trim() === vehicleId)
//           .filter((b) => isScheduledCandidate(b))
//           .filter((b) => isPendingStatus(b?.status))
//           .filter((b) => b?.bsTime);
//         const sorted = due.sort((a, b) => {
//           const aTime = parseBookingDateTime(a.bsTime)?.getTime() || 0;
//           const bTime = parseBookingDateTime(b.bsTime)?.getTime() || 0;
//           return aTime - bTime;
//         });
//         for (const booking of sorted) {
//           const bId = booking?.bId;
//           if (!bId) continue;
//           const key = String(bId);
//           if (scheduledShownRef.current.has(key)) continue;
//           const startTime = parseBookingDateTime(booking.bsTime);
//           if (!startTime) continue;
//           const diff = now.getTime() - startTime.getTime();
//           if (diff >= 0 && diff <= windowMs) {
//             const scheduledBooking = { ...booking, BookingStatus: normalizeBookingStatusCode(booking) };
//             setIncomingBooking(scheduledBooking);
//             setIsOverlayVisible(true);
//             scheduledShownRef.current.add(key);
//             toast.info("Scheduled trip time reached", { position: "top-center", autoClose: 6000 });
//             break;
//           }
//         }
//       } catch (err) {
//         console.error("Scheduled booking poll failed:", err);
//       }
//     };
//     pollScheduled();
//     const interval = setInterval(pollScheduled, 30000);
//     return () => {
//       isMounted = false;
//       clearInterval(interval);
//     };
//   }, [isOnline, authKey, currentVehicle?.vehicleId, userDetails?.ServiceNo, isOverlayVisible, isProcessing]);

//   useEffect(() => {
//     if (!isOnline || !authKey || !currentVehicle || !userDetails?.ServiceNo) {
//       signalrService.disconnect();
//       bookingWS.disconnect();
//       clearInterval(locationInterval.current);
//       return;
//     }

//     signalrService.connect(authKey, userDetails.ServiceNo);
//     bookingWS.connect(authKey, userDetails.ServiceNo, currentVehicle.vehicleId);
//     chatWS.connect(authKey, userDetails.ServiceNo, "Driver");

//     const processIncomingBooking = async (booking) => {
//       // Preserve reqId from original booking, if not present, fetch it
//       let reqIdValue = booking.reqId || booking.ReqId || booking.requestId || booking.bookingReqId;
      
//       // If reqId is missing, fetch it from API
//       if (!reqIdValue && booking.bId) {
//         reqIdValue = await fetchReqIdByBookingId(booking.bId);
//       }
      
//       const bIdIsValid = booking.bId && !String(booking.bId).startsWith("TEMP") && !isNaN(parseInt(booking.bId));

//       if (bIdIsValid) {
//         if (booking.dSNo && userDetails?.ServiceNo && booking.dSNo.toString() === userDetails.ServiceNo.toString()) {
//           const bookingWithReqId = {
//             ...booking,
//             reqId: reqIdValue,
//             ReqId: reqIdValue,
//             requestId: reqIdValue,
//           };
//           setIncomingBooking(bookingWithReqId);
//           setIsOverlayVisible(true);
//           toast.info(`New Trip Request #${booking.bId}`, { position: "top-center", autoClose: 6000 });
//         }
//       } else {
//         try {
//           let latestPendingBooking = null;
//           if (booking?.vId) {
//             const byVehicle = await getBookingDetailsByVehicleId(booking.vId);
//             latestPendingBooking = (byVehicle || [])
//               .filter(b => String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
//                 (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
//               .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
//           }
//           if (!latestPendingBooking) {
//             const allBookings = await getBookings();
//             latestPendingBooking = (allBookings || [])
//               .filter(b => String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
//                 (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
//               .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
//           }
//           if (!latestPendingBooking) {
//             const forkBookings = await getForkBookingDetailsAll();
//             latestPendingBooking = (forkBookings || [])
//               .filter(b => String(b?.vId || "").trim() === String(booking?.vId || "").trim() &&
//                 String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
//                 (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
//               .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
//           }
//           if (latestPendingBooking) {
//             const actualBooking = {
//               ...booking,
//               ...latestPendingBooking,
//               reqId: reqIdValue,
//               ReqId: reqIdValue,
//               requestId: reqIdValue,
//               bId: latestPendingBooking.bId,
//               vehicle_id: latestPendingBooking.vehicle_id || latestPendingBooking.vId || 0,
//             };
//             setIncomingBooking(actualBooking);
//             setIsOverlayVisible(true);
//             toast.info(`New Trip Request #${actualBooking.bId}`, { position: "top-center", autoClose: 6000 });
//           } else {
//             const fallbackBooking = {
//               ...booking,
//               reqId: reqIdValue,
//               ReqId: reqIdValue,
//               requestId: reqIdValue,
//               vehicle_id: booking.vehicle_id || booking.vId || 0,
//             };
//             setIncomingBooking(fallbackBooking);
//             setIsOverlayVisible(true);
//             toast.warning("Booking notification received but limited details available", { position: "top-center" });
//           }
//         } catch (err) {
//           console.error("Failed to fetch booking:", err);
//           const fallbackBooking = { ...booking, reqId: reqIdValue, ReqId: reqIdValue, requestId: reqIdValue };
//           setIncomingBooking(fallbackBooking);
//           setIsOverlayVisible(true);
//           toast.info(`New Trip Request`, { position: "top-center", autoClose: 6000 });
//         }
//       }
//     };

//     signalrService.onNewBooking((booking) => {
//       if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
//         const currentBooking = incomingBookingRef.current;
//         if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
//           incomingBookingRef.current = null;
//           setIncomingBooking(null);
//           setIsOverlayVisible(false);
//           toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
//         }
//         return;
//       }
//       processIncomingBooking(booking);
//     });

//     bookingWS.onNewBooking((booking) => {
//       if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
//         const currentBooking = incomingBookingRef.current;
//         if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
//           incomingBookingRef.current = null;
//           setIncomingBooking(null);
//           setIsOverlayVisible(false);
//           toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
//         }
//         return;
//       }
//       processIncomingBooking(booking);
//     });

//     if (locationInterval.current) clearInterval(locationInterval.current);
//     locationInterval.current = setInterval(() => {
//       updateVehicleLocation();
//     }, 30000);

//     return () => {
//       signalrService.disconnect();
//       bookingWS.disconnect();
//       if (locationInterval.current) clearInterval(locationInterval.current);
//     };
//   }, [isOnline, authKey, currentVehicle, userDetails?.ServiceNo]);

//   useEffect(() => {
//     const timer = setTimeout(fetchWeatherAlert, 5000);
//     return () => clearTimeout(timer);
//   }, [vehicleLocation]);

//   useEffect(() => {
//     if (isOnline && locationWS.isReady()) {
//       locationWS.updateDriverData({
//         latitude: vehicleLocation.latitude,
//         longitude: vehicleLocation.longitude,
//       });
//     }
//   }, [vehicleLocation, isOnline]);

//   if (!authKey) {
//     return <div className="text-center py-20 text-xl">Please log in</div>;
//   }

//   return (
//     <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
//       <DriverHeader driver={driver} isOnline={isOnline} toggleOnline={toggleOnlineStatus} />

//       <main className="flex-1 px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8 max-w-7xl mx-auto w-full space-y-4 sm:space-y-6 md:space-y-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
//           <div className="bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow flex items-center gap-2 sm:gap-3 md:gap-4">
//             <div className="flex flex-1 flex-row items-center gap-2 sm:gap-3 md:gap-4">
//               <div className="relative flex-shrink-0">
//                 <img
//                   src={driver.profilePic}
//                   alt="Profile"
//                   onClick={() => setIsProfileDetailsVisible(true)}
//                   className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full border-4 border-blue-300 object-cover cursor-pointer hover:border-blue-500 transition-all"
//                   onError={(e) => { e.target.src = defaultUserImg; }}
//                 />
//                 <button
//                   onClick={() => fileInputRef.current?.click()}
//                   disabled={isUploadingPic}
//                   className="absolute bottom-0 right-0 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-1 sm:p-1.5 shadow-lg transition disabled:bg-gray-400"
//                 >
//                   {isUploadingPic ? (
//                     <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-4 md:h-4 animate-spin" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                   ) : (
//                     <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                   )}
//                 </button>
//                 <input ref={fileInputRef} type="file" accept="image/*" onChange={handleProfilePictureChange} className="hidden" />
//               </div>
//               <div className="flex-1 min-w-0">
//                 <h2 className="text-sm sm:text-base md:text-xl lg:text-2xl font-bold text-blue-900 truncate">{driver.name}</h2>
//                 <div className="text-[10px] sm:text-xs md:text-sm text-gray-700 space-y-0.5 sm:space-y-1">
//                   <p className="truncate"><strong>ID:</strong> {driver.driverSno}</p>
//                   {driver.vehicleId ? (
//                     <div className="flex items-center gap-2 bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-200 rounded-lg px-3 py-2 mt-1">
//                       <div className="flex-1 min-w-0">
//                         <p className="text-[10px] sm:text-xs font-semibold text-indigo-900 truncate">{driver.vehicleId}</p>
//                         <p className="text-[9px] sm:text-[10px] text-indigo-600">{driver.vehicleType || 'Unknown'}</p>
//                       </div>
//                       <div className="flex-shrink-0">
//                         <img src={getVehicleIcon(driver.vehicleType)} alt={`${driver.vehicleType} icon`} className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
//                       </div>
//                     </div>
//                   ) : (
//                     <p className="truncate text-gray-500 italic"><strong>Vehicle:</strong> No Vehicle Assigned Yet</p>
//                   )}
//                   <p className="truncate"><strong>Mobile:</strong> {driver.mobileNo}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="flex flex-col items-center justify-center flex-shrink-0">
//               <span className={`mb-2 sm:mb-3 text-[11px] sm:text-sm font-semibold px-3 py-1 rounded-full animate-pulse ${isOnline ? "bg-green-100 text-green-800" : "bg-gray-200 text-gray-700"}`}>
//                 {isOnline ? "You are now online" : "You are now offline"}
//               </span>
//               <button
//                 onClick={toggleOnlineStatus}
//                 disabled={isUpdatingStatus || !driver.vehicleId}
//                 className={`px-3 sm:px-6 md:px-8 lg:px-12 py-2 sm:py-3 md:py-4 lg:py-5 rounded-lg sm:rounded-xl md:rounded-2xl font-bold text-[10px] sm:text-sm md:text-base lg:text-xl transition-all transform shadow-lg whitespace-nowrap ${!driver.vehicleId ? "bg-gray-400 cursor-not-allowed opacity-60" : isOnline ? "bg-red-600 hover:bg-red-700 hover:scale-105" : "bg-green-600 hover:bg-green-700 hover:scale-105"} text-white ${isUpdatingStatus ? "opacity-70 cursor-not-allowed" : ""}`}
//               >
//                 {isUpdatingStatus ? "Updating..." : isOnline ? "GO OFFLINE" : "GO ONLINE"}
//               </button>
//               {!driver.vehicleId && (
//                 <p className="mt-2 text-xs sm:text-sm font-semibold text-red-600 bg-red-50 px-3 py-1 rounded-lg border border-red-200 animate-pulse">⚠️ Vehicle Not Assigned Yet</p>
//               )}
//               {isOnline && hasActiveBooking && (
//                 <p className="mt-2 text-[10px] sm:text-xs md:text-sm font-semibold text-red-600 bg-red-50 px-2 py-1 rounded-lg border border-red-200 animate-pulse text-center max-w-[180px] sm:max-w-none">⚠️ Cannot go offline during active hire</p>
//               )}
//               <button onClick={() => navigate("/driver/scheduled-bookings")} className="mt-3 px-3 sm:px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] sm:text-xs md:text-sm font-semibold shadow transition-all">View Scheduled Bookings</button>
//             </div>
//           </div>

//           <div className="bg-gradient-to-r from-amber-50 to-orange-100 p-4 sm:p-5 md:p-6 rounded-xl shadow-lg border border-amber-200">
//             <div className="flex items-center gap-3 sm:gap-4">
//               <div className="text-2xl sm:text-3xl md:text-4xl">🌤️</div>
//               <div className="flex-1">
//                 <h3 className="text-sm sm:text-base md:text-xl font-bold text-amber-900">Weather Alert</h3>
//                 <p className="text-xs sm:text-sm md:text-base text-amber-800 font-medium">{weatherAlert}</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-lg overflow-hidden" style={{ position: "relative", zIndex: "auto" }}>
//           <div className="bg-blue-900 text-white p-3 sm:p-4">
//             <h2 className="text-base sm:text-lg md:text-xl font-bold">Live Vehicle Location</h2>
//           </div>
//           <div style={{ height: "300px", zIndex: 1 }} className="sm:h-96 md:h-[500px]">
//             <style>{`.leaflet-container { z-index: 1 !important; } .leaflet-popup { z-index: 2 !important; } .leaflet-control { z-index: 2 !important; }`}</style>
//             <MapContainer center={[vehicleLocation.latitude, vehicleLocation.longitude]} zoom={16} style={{ height: "100%", width: "100%", zIndex: 1 }}>
//               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//               <RecenterButton position={[vehicleLocation.latitude, vehicleLocation.longitude]} zoom={16} />
//               <AnimatedMapCenter position={[vehicleLocation.latitude, vehicleLocation.longitude]} />
//               {hasLocationFix && (
//                 <CircleMarker center={[vehicleLocation.latitude, vehicleLocation.longitude]} radius={14} fillColor="#2563eb" color="#1d4ed8" weight={6} opacity={1} fillOpacity={0.9}>
//                   <Popup>
//                     <strong className="text-xs sm:text-sm">{driver.vehicleId}</strong><br className="hidden sm:block" />
//                     <span className="text-xs sm:text-sm">{driver.vehicleType}</span><br className="hidden sm:block" />
//                     <span className="text-xs sm:text-sm">Driver: {driver.name}</span>
//                   </Popup>
//                 </CircleMarker>
//               )}
//             </MapContainer>
//           </div>
//         </div>

//         <ActiveBookingsPanel driverSno={driver.driverSno} isOnline={isOnline} />
//       </main>

//       <BookingAlertOverlay
//         isProcessing={isProcessing}
//         booking={incomingBooking}
//         isVisible={isOverlayVisible}
//         onAccept={handleAcceptBooking}
//         onCancel={handleCancelBooking}
//       />

//       <UserDetailsOverlay
//         isVisible={isProfileDetailsVisible}
//         onClose={() => setIsProfileDetailsVisible(false)}
//         userDetails={driver}
//         userRole="Driver"
//         fileInputRef={fileInputRef}
//         onProfilePictureChange={handleProfilePictureChange}
//         isUploadingPic={isUploadingPic}
//         onMobileNumberUpdate={handleMobileNumberUpdate}
//         isUpdatingMobile={isUpdatingMobile}
//         canEditMobile={true}
//         onPasswordChange={handlePasswordChange}
//         isUpdatingPassword={isUpdatingPassword}
//         canChangePassword={true}
//       />

//       <ProfilePictureCropper isOpen={showCropper} onClose={handleCropperClose} onCropComplete={handleCropComplete} imageSrc={selectedImage} />
//       <DriverFooter />

//       <EmergencyAlertModal isOpen={isEmergencyModalOpen} onClose={() => setIsEmergencyModalOpen(false)} onSend={handleSendEmergency} isSending={isSendingEmergency} />

//       <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[9999] flex flex-col items-end font-sans">
//         <AnimatePresence>
//           {!isSosExpanded ? (
//             <motion.button initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 300, damping: 30 }} onClick={() => setIsSosExpanded(true)} className="bg-red-50 hover:bg-red-100 border-l-[3px] md:border-l-4 border-red-600 shadow-xl py-4 pl-2 pr-0.5 rounded-l-xl md:py-2 md:pl-1 md:pr-0 md:rounded-l-lg flex items-center justify-center transition-colors" title="SOS">
//               <ChevronLeft className="w-5 h-5 md:w-3 md:h-3 text-red-600" />
//             </motion.button>
//           ) : (
//             <motion.div initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 300, damping: 30 }} className="bg-white border md:border-l-4 border-red-600 shadow-2xl rounded-l-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 mr-0" style={{ maxWidth: "90vw" }}>
//               <button onClick={() => setIsSosExpanded(false)} className="p-1.5 md:p-1 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-600 transition-colors flex-shrink-0">
//                 <ChevronRight className="w-5 h-5 md:w-3 md:h-3" />
//               </button>
//               <div className="flex flex-col items-center gap-1 md:gap-2 min-w-0">
//                 <span className="text-[10px] md:text-sm font-bold text-red-800 uppercase tracking-wider whitespace-nowrap">Emergency</span>
//                 <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={handleOpenEmergency} className="flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-red-700 text-white shadow-lg border-2 md:border-4 border-red-100 ring-2 md:ring-4 ring-red-500/20">
//                   <div className="flex flex-col items-center">
//                     <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 mb-0.5" />
//                     <span className="text-[9px] md:text-[10px] font-black">SOS</span>
//                   </div>
//                 </motion.button>
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>

//       {activeHire && (
//         <HireAssistanceBubble
//           hireData={activeHire}
//           driverInfo={{
//             name: driver.name,
//             phone: driver.mobileNo,
//             rating: 4.8,
//             vehicleInfo: `${driver.vehicleType} • ${driver.vehicleId}`,
//             profileImage: driver.profilePic,
//           }}
//           driverLocation={{ lat: vehicleLocation.latitude, lng: vehicleLocation.longitude }}
//           onCallDriver={() => { if (driver.mobileNo) window.location.href = `tel:${driver.mobileNo}`; }}
//           onMessageDriver={() => toast.info("Messaging feature coming soon!")}
//           onEmergency={handleOpenEmergency}
//           isLocationSharing={isOnline}
//         />
//       )}
//     </div>
//   );
// };

// export default DriverDashboard;




// src/pages/DriverDashboard.jsx
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  MapContainer,
  TileLayer,
  Popup,
  CircleMarker,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import RecenterButton from "../components/RecenterButton";
import L from "leaflet";
import DriverHeader from "../components/DriverHeader";
import DriverFooter from "../components/DriverFooter";
import ProfilePictureCropper from "../components/ProfilePictureCropper";
import UserDetailsOverlay from "../components/UserDetailsOverlay";
import ActiveBookingsPanel from "../components/ActiveBookingsPanel";
import HireAssistanceBubble from "../components/HireAssistanceBubble";
import { useDispatch, useSelector } from "react-redux";
import BookingAlertOverlay from "../components/BookingAlertOverlay";
import EmergencyAlertModal from "../components/EmergencyAlertModal";
import api from "../services/api";
import { updateEmergency } from "../services/vehicleService";
import { calculateDistance, estimateETA, calculateFare } from "../services/mapsService";
import signalrService from "../services/signalr";
import locationWS from "../services/locationWebSocket";
import bookingWS from "../services/bookingWebSocket";
import chatWS from "../services/chatWebSocket";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { getProfilePictureUrl } from "../services/userService";
import { ChevronLeft, ChevronRight, AlertTriangle } from "lucide-react";
import { defaultUserImg } from "../assets/defaultUser";
import { fetchBookings } from "../actions/BookingActions";
import { fetchUsers } from "../actions/UserActions";
import { fetchVehicles } from "../actions/VehicleActions";
import { getBookingDetailsByVehicleId, getForkBookingDetailsAll } from "../services/bookingService";
import { DEFAULT_MAP_CENTER } from "../constants/mapDefaults";
import { AdminFindNearestDriver, AdminAcceptBooking } from "../actions/AdminBookingRequestAction";
import { addDeclinedVehicle } from "../utils/declinedVehicles";

// Import vehicle icons
import carIcon from "../assets/car.png";
import vanIcon from "../assets/van.png";
import busIcon from "../assets/bus.png";
import lorryIcon from "../assets/lorry.png";
import suvIcon from "../assets/suv.png";
import cabIcon from "../assets/cab.png";
import forkliftIcon from "../assets/fork lift.png";
import dockyardIcon from "../assets/dockyard.png";
import cherryIcon from "../assets/cherry.png";
import craneIcon from "../assets/crane.jpg";

// Fix Leaflet icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const AnimatedMapCenter = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position && map && map._container) {
      try {
        map.flyTo(position, 16, { animate: true, duration: 1.5 });
      } catch (err) {
        console.warn("Map animation error:", err);
      }
    }
  }, [position, map]);
  return null;
};

const DriverDashboard = () => {
  const dispatch = useDispatch();
  const { authKey, userDetails } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [driver, setDriver] = useState({
    name: "",
    driverSno: "",
    vehicleId: "",
    vehicleType: "",
    weightCat: "",
    mobileNo: "",
    profilePic: defaultUserImg,
    role: "D",
    status: "A",
    password: "",
    file_path: null,
  });

  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [isOnline, setIsOnline] = useState(false);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [hasActiveBooking, setHasActiveBooking] = useState(false);

  const [vehicleLocation, setVehicleLocation] = useState({
    latitude: DEFAULT_MAP_CENTER[0],
    longitude: DEFAULT_MAP_CENTER[1],
  });
  const [hasLocationFix, setHasLocationFix] = useState(false);

  const [incomingBooking, setIncomingBooking] = useState(null);
  const incomingBookingRef = useRef(null);
  const scheduledShownRef = useRef(new Set());
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProfileDetailsVisible, setIsProfileDetailsVisible] = useState(false);
  const [weatherAlert, setWeatherAlert] = useState("Loading weather...");
  const [isUploadingPic, setIsUploadingPic] = useState(false);

  const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
  const [isSendingEmergency, setIsSendingEmergency] = useState(false);
  const [isSosExpanded, setIsSosExpanded] = useState(false);
  // New states added for drivers to be able to cancel emergency alerts as well
  const [hasActiveEmergency, setHasActiveEmergency] = useState(false);
  const [isResolvingEmergency, setIsResolvingEmergency] = useState(false);

  const [isUpdatingMobile, setIsUpdatingMobile] = useState(false);
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  const [activeHire, setActiveHire] = useState(null);
  const [hireStage, setHireStage] = useState('accepted');
  const [pickupLocation, setPickupLocation] = useState(null);
  const [destinationLocation, setDestinationLocation] = useState(null);

  const getBookings = async () => dispatch(fetchBookings());
  const getUsers = async () => dispatch(fetchUsers());
  const getVehicles = async () => dispatch(fetchVehicles());

  const locationInterval = useRef(null);

  const getVehicleIcon = (vehicleType) => {
    const type = vehicleType?.toUpperCase()?.trim() || "";
    if (type === "V" || type.includes("VAN")) return vanIcon;
    if (type === "B" || type.includes("BUS")) return busIcon;
    if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) return lorryIcon;
    if (type === "S" || type.includes("SUV")) return suvIcon;
    if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) return cabIcon;
    if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) return forkliftIcon;
    if (type === "CR" || type.includes("CRANE")) return craneIcon;
    if (type.includes("DOCKYARD")) return dockyardIcon;
    if (type === "CH" || type.includes("CHERRY")) return cherryIcon;
    if (type === "C" || type.includes("CAR")) return carIcon;
    return carIcon;
  };

  const mapRole = (r) => {
    if (!r) return "D";
    const v = r.toString().trim().toUpperCase();
    switch (v) {
      case "S": return "S";
      case "E": return "E";
      case "A": return "A";
      case "EN": return "EN";
      case "D": return "D";
      default: return "D";
    }
  };

  const mapStatus = (s) => {
    const v = s?.toString().trim().toUpperCase();
    return v === "ACTIVE" || v === "A" ? "A" : "I";
  };

  const normalizeVehicleType = (type) => {
    const t = (type ?? "").toString().trim();
    const typeCodeMap = {
      Car: "C", Van: "V", Lorry: "L", SUV: "S", Cab: "CA",
      Bus: "B", "Cherry Picker": "CH", Forklift: "F", Crane: "CR", Trailer: "T",
    };
    if (typeCodeMap[t]) return typeCodeMap[t];
    if (t.length > 0 && t.length <= 2) return t;
    return "C";
  };

  const normalizeBStatus = (value) => {
    const v = (value ?? "").toString().trim().toUpperCase();
    if (!v) return "";
    if (v.startsWith("P")) return "P";
    if (v.startsWith("B")) return "B";
    if (v.startsWith("C")) return "C";
    return v.length <= 2 ? v : v[0];
  };

  const getCurrentLocation = () => {
    return new Promise((resolve) => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const location = {
              latitude: pos.coords.latitude.toFixed(6),
              longitude: pos.coords.longitude.toFixed(6),
            };
            setHasLocationFix(true);
            resolve(location);
          },
          () => resolve(vehicleLocation),
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 }
        );
      } else {
        resolve(vehicleLocation);
      }
    });
  };

  const updateVehicleInDB = async (newOStatus = null) => {
    if (!currentVehicle) return;
    const location = await getCurrentLocation();
    const vehicleTypeCode = normalizeVehicleType(currentVehicle.vehicleType || currentVehicle.vehicle_type);
    const statusCode = currentVehicle.status === "Active" ? "A" :
      currentVehicle.status === "Inactive" ? "I" :
        currentVehicle.status || "A";
    const oStatusValue = newOStatus || (isOnline ? "O" : "F");
    const bStatusValue = normalizeBStatus(currentVehicle.bStatus);

    const payload = [{
      vehicleId: currentVehicle.vehicleId,
      vehicleType: vehicleTypeCode,
      weightCat: currentVehicle.weightCat || "",
      driverSno: currentVehicle.driverSno || "",
      status: statusCode,
      bStatus: bStatusValue,
      oStatus: oStatusValue,
      latitude: oStatusValue === "F" ? "" : location.latitude,
      longitude: oStatusValue === "F" ? "" : location.longitude,
    }];

    try {
      await api.post("/VehicleRegister/PostVehicleDetails", payload);
      setVehicleLocation({
        latitude: parseFloat(location.latitude),
        longitude: parseFloat(location.longitude),
      });
    } catch (err) {
      console.error("Failed to save location/status:", err);
    }
  };

  const updateVehicleBookingStatus = async (newBStatus = "B") => {
    if (!currentVehicle) return;
    const location = await getCurrentLocation();
    const vehicleTypeCode = normalizeVehicleType(currentVehicle.vehicleType || currentVehicle.vehicle_type);
    const statusCode = currentVehicle.status === "Active" ? "A" :
      currentVehicle.status === "Inactive" ? "I" :
        currentVehicle.status || "A";
    const bStatusValue = normalizeBStatus(newBStatus);
    const oStatusValue = isOnline ? "O" : "F";

    const payload = [{
      vehicleId: currentVehicle.vehicleId,
      vehicleType: vehicleTypeCode,
      weightCat: currentVehicle.weightCat || "",
      driverSno: currentVehicle.driverSno || "",
      status: statusCode,
      bStatus: bStatusValue,
      oStatus: oStatusValue,
      latitude: location.latitude,
      longitude: location.longitude,
    }];

    try {
      await api.post("/VehicleRegister/PostVehicleDetails", payload);
      setCurrentVehicle({
        ...currentVehicle,
        bStatus: newBStatus,
      });
    } catch (err) {
      console.error("Failed to update vehicle booking status:", err);
    }
  };

  const updateVehicleLocation = async () => {
    if (!currentVehicle) return;
    const location = await getCurrentLocation();
    const statusCode = currentVehicle.status === "Active" ? "A" :
      currentVehicle.status === "Inactive" ? "I" :
        currentVehicle.status || "A";

    const payload = [{
      vehicleId: currentVehicle.vehicleId,
      status: statusCode,
      latitude: location.latitude,
      longitude: location.longitude,
    }];

    try {
      await api.post("/VehicleRegister/UpdateVehicleLocation", payload);
      setVehicleLocation({
        latitude: parseFloat(location.latitude),
        longitude: parseFloat(location.longitude),
      });
    } catch (err) {
      console.error("Failed to update vehicle location:", err);
    }
  };

  const isActiveBookingStatus = (value) => {
    const s = String(value || "").trim().toUpperCase();
    return (
      s === "A" || s === "ACTIVE" || s === "EN" || s === "ENROUTE" ||
      s === "IP" || s === "INPROGRESS" || s === "IN PROGRESS"
    );
  };

  const handleOpenEmergency = () => {
    setIsEmergencyModalOpen(true);
  };

  const handleSendEmergency = async ({ ecode, ediscription }) => {
    if (!driver.vehicleId) {
      toast.error("No vehicle assigned. Cannot send alert.");
      return;
    }

    setIsSendingEmergency(true);
    try {
      let activeBooking = null;
      if (hasActiveBooking) {
        try {
          const allBookings = await getBookings();
          const driverId = driver.driverSno || userDetails?.ServiceNo;
          const vehicleId = driver.vehicleId;
          const activeStatuses = ["A", "ACTIVE", "EN", "ENROUTE", "IP", "INPROGRESS", "IN PROGRESS"];
          const candidates = allBookings.filter((b) => {
            const status = (b.status || "").toString().trim().toUpperCase();
            return (
              driverId && vehicleId &&
              b.dSNo?.toString() === driverId.toString() &&
              b.vId?.toString() === vehicleId.toString() &&
              activeStatuses.includes(status)
            );
          });
          if (candidates.length > 0) {
            activeBooking = [...candidates].sort((a, b) => {
              const aTime = new Date(a.bookingDT || a.bsTime || 0).getTime();
              const bTime = new Date(b.bookingDT || b.bsTime || 0).getTime();
              return bTime - aTime;
            })[0];
          }
        } catch (findErr) {
          console.error("Failed to find active booking for SOS:", findErr);
        }
      }

      await updateEmergency(driver.vehicleId, ecode, ediscription);
      // Now that the emergency has been sent, record that there is an active emergency
      setHasActiveEmergency(true);

      chatWS.sendEmergency({
        vehicleId: driver.vehicleId,
        ecode: ecode,
        ediscription: ediscription,
        driverName: driver.name || "Unknown Driver",
        driverSno: driver.driverSno,
        mobileNo: driver.mobileNo,
        ...(activeBooking ? {
          bId: activeBooking.bId,
          bookingSno: activeBooking.bookingSno || activeBooking.BookingSno || "",
          bookingStatus: activeBooking.status,
        } : {}),
      });

      if (!hasActiveBooking && isOnline && currentVehicle) {
        try {
          await updateVehicleInDB("F");
          setIsOnline(false);
          setCurrentVehicle({ ...currentVehicle, oStatus: "F" });
          locationWS.disconnect();
        } catch (statusErr) {
          console.error("Failed to update vehicle offline status after SOS:", statusErr);
        }
      }

      toast.success("EMERGENCY ALERT SENT! Help is on the way.");
      setIsEmergencyModalOpen(false);
    } catch (error) {
      console.error("Emergency Alert Failed:", error);
      toast.error("Failed to send alert! Please call emergency services.");
    } finally {
      setIsSendingEmergency(false);
    }
  };

  // Function to let drivers cancel emergencies
  const handleResolveEmergency = async () => {
    if (!driver.vehicleId) return;

    const confirmed = window.confirm(
      "Are you sure the emergency has been resolved?"
    );

    if (!confirmed) return;

    setIsResolvingEmergency(true);

    try {
      await updateEmergency(driver.vehicleId, "", "");

      chatWS.sendEmergency({
        vehicleId: driver.vehicleId,
        ecode: "",
        ediscription: "",
        driverName: driver.name,
        driverSno: driver.driverSno,
        mobileNo: driver.mobileNo
      });

      // Clear the local current vehicle ecode so that drivers can go online immediately
      setCurrentVehicle(prev => ({
        ...prev,
        ecode: "",
        edescription: ""
      }));

      setHasActiveEmergency(false);

      if (currentVehicle) {
        setCurrentVehicle({
          ...currentVehicle,
          ecode: "",
          edescription: ""
        });
      }

      toast.success("Emergency alert cleared");

    } catch (err) {
      console.error(err);
      toast.error("Failed to clear emergency alert");
    } finally {
      setIsResolvingEmergency(false);
    }
  }

  const toggleOnlineStatus = async () => {
    if (!currentVehicle || isUpdatingStatus) return;
    const willBeOnline = !isOnline;
    setIsUpdatingStatus(true);

    try {
      if (isOnline && hasActiveBooking) {
        try {
          const driverId = String(userDetails?.ServiceNo || "").trim();
          const vehicleId = String(currentVehicle?.vehicleId || "").trim();
          const allBookings = await getBookings();
          const active = (allBookings || []).some((b) => {
            return (
              String(b?.dSNo || "").trim() === driverId &&
              String(b?.vId || "").trim() === vehicleId &&
              isActiveBookingStatus(b?.status)
            );
          });
          if (active) {
            toast.error("Cannot go offline during active hire", { position: "top-center", autoClose: 3000 });
            return;
          }
          setHasActiveBooking(false);
          await updateVehicleBookingStatus("");
          setCurrentVehicle({ ...currentVehicle, bStatus: "" });
        } catch (err) {
          console.error("Failed to re-check active booking:", err);
          toast.error("Unable to verify booking status. Try again.", { position: "top-center", autoClose: 3000 });
          return;
        }
      }

      if (willBeOnline) {
        try {
          const vehicles = await getVehicles();
          const driverId = userDetails?.ServiceNo;
          const assigned = vehicles.find(
            (v) => (v.vehicleId && currentVehicle.vehicleId && v.vehicleId.toString() === currentVehicle.vehicleId.toString()) ||
              (driverId && v.driverSno && v.driverSno.toString() === driverId.toString())
          );
          const hasActiveSOS = !!(assigned?.ecode && assigned.ecode.toString().trim() !== "");
          if (hasActiveSOS) {
            toast.error("You cannot go ONLINE while an emergency alert is active. Please wait until admin resolves it.", { position: "top-center", autoClose: 4000 });
            return;
          }
        } catch (checkErr) {
          console.error("Failed to verify SOS status before going ONLINE:", checkErr);
          toast.error("Unable to verify emergency status. Please try again in a moment.", { position: "top-center", autoClose: 4000 });
          return;
        }
      }

        const statusPayload = [{
          oStatus: willBeOnline ? "O" : "F",
          latitude: vehicleLocation?.latitude ?? "",
          longitude: vehicleLocation?.longitude ?? "",
          vehicleId: currentVehicle.vehicleId,
        }];
        await api.post("/VehicleRegister/UpdateVehicleStatus", statusPayload);
      setIsOnline(willBeOnline);
      setCurrentVehicle({ ...currentVehicle, oStatus: willBeOnline ? "O" : "F" });

      if (willBeOnline) {
        const locationData = {
          vehicleId: currentVehicle.vehicleId,
          driverSno: currentVehicle.driverSno || userDetails?.ServiceNo,
          driverName: driver.name,
          vehicle_type: currentVehicle.vehicleType,
          latitude: vehicleLocation.latitude,
          longitude: vehicleLocation.longitude,
          status: currentVehicle.status || "Active",
          bStatus: currentVehicle.bStatus || "",
          oStatus: "O",
        };
        locationWS.connect(authKey, locationData);
      } else {
        locationWS.disconnect();
      }

      toast.success(`You are now ${willBeOnline ? "ONLINE" : "OFFLINE"}!`, { position: "top-center", autoClose: 2500 });
    } catch (err) {
      toast.error("Failed to update status. Try again.");
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  const fetchDriverAndVehicle = async () => {
    try {
      const [users, vehicles] = await Promise.all([getUsers(), getVehicles()]);
      if (Array.isArray(users)) {
        const thisDriver = users.find((u) => u.ServiceNo === userDetails.ServiceNo);
        if (thisDriver) {
          setDriver((prev) => ({
            ...prev,
            name: thisDriver.Name || "Driver",
            driverSno: thisDriver.ServiceNo,
            mobileNo: thisDriver.MobileNo || "N/A",
            profilePic: getProfilePictureUrl(thisDriver.ServiceNo),
            role: mapRole(thisDriver.role),
            status: mapStatus(thisDriver.status),
            password: thisDriver.password || "",
            file_path: thisDriver.file_path || null,
          }));
        }
      }

      if (Array.isArray(vehicles)) {
        const assignedVehicle = vehicles.find((v) => v.driverSno === userDetails.ServiceNo);
        if (assignedVehicle) {
          setCurrentVehicle(assignedVehicle);

          // Check if the vehicle has an emergency - it will have an ecode if there is an emergency
          setHasActiveEmergency(
            !!assignedVehicle?.ecode && assignedVehicle.ecode.trim() !== ""
          )

          const dbOStatus = (assignedVehicle.oStatus || "").trim();
          const online = dbOStatus === "O" || dbOStatus === "Online";
          setIsOnline(online);
          setDriver((prev) => ({
            ...prev,
            vehicleId: assignedVehicle.vehicleId,
            vehicleType: assignedVehicle.vehicleType || "Unknown",
            weightCat: assignedVehicle.weightCat || "",
          }));

          const hasValidCoords = assignedVehicle.latitude && assignedVehicle.longitude &&
            !isNaN(parseFloat(assignedVehicle.latitude)) && !isNaN(parseFloat(assignedVehicle.longitude));

          if (hasValidCoords) {
            setVehicleLocation({
              latitude: parseFloat(assignedVehicle.latitude),
              longitude: parseFloat(assignedVehicle.longitude),
            });
            setHasLocationFix(true);
          } else {
            getCurrentLocation().then((liveLocation) => {
              setVehicleLocation({
                latitude: parseFloat(liveLocation.latitude),
                longitude: parseFloat(liveLocation.longitude),
              });
              setHasLocationFix(true);
            }).catch(() => {
              setVehicleLocation({ latitude: DEFAULT_MAP_CENTER[0], longitude: DEFAULT_MAP_CENTER[1] });
            });
          }
        }
      }
    } catch (err) {
      toast.error("Failed to load profile");
      console.error(err);
    }
  };

  const fetchWeatherAlert = async () => {
    try {
      const { latitude, longitude } = vehicleLocation;
      const weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`;
      const res = await fetch(weatherUrl);
      const data = await res.json();
      const code = data.current_weather?.weathercode;
      const desc = {
        0: "Clear sky", 1: "Mainly clear", 2: "Partly cloudy", 3: "Overcast",
        45: "Fog", 51: "Light drizzle", 61: "Light rain", 63: "Rain", 65: "Heavy rain",
        71: "Light snow", 80: "Rain showers", 95: "Thunderstorm",
      }[code] || "Weather info unavailable";
      setWeatherAlert(desc);
    } catch {
      setWeatherAlert("Weather service unavailable");
    }
  };

  const handleProfilePictureChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Image size should be less than 10MB");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedImage(reader.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCropComplete = async (croppedBlob) => {
    setShowCropper(false);
    setIsUploadingPic(true);
    try {
      const croppedFile = new File([croppedBlob], "profile.jpg", { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("ServiceNo", driver.driverSno);
      formData.append("Name", driver.name);
      formData.append("MobileNo", driver.mobileNo);
      formData.append("role", driver.role);
      formData.append("status", driver.status);
      formData.append("password", driver.password || "");
      formData.append("ImageFile", croppedFile);
      if (driver.file_path) {
        formData.append("file_path", driver.file_path);
      }
      await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
      const timestamp = Date.now();
      const newPicUrl = `${getProfilePictureUrl(driver.driverSno)}&t=${timestamp}`;
      setDriver((prev) => ({ ...prev, profilePic: newPicUrl }));
      toast.success("Profile picture updated successfully!");
    } catch (err) {
      console.error("Failed to upload profile picture:", err);
      toast.error("Failed to update profile picture");
    } finally {
      setIsUploadingPic(false);
      setSelectedImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleCropperClose = () => {
    setShowCropper(false);
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleMobileNumberUpdate = async (newMobileNumber) => {
    setIsUpdatingMobile(true);
    try {
      const formData = new FormData();
      formData.append("ServiceNo", driver.driverSno);
      formData.append("Name", driver.name);
      formData.append("MobileNo", newMobileNumber);
      formData.append("role", driver.role);
      formData.append("status", driver.status);
      formData.append("password", driver.password || "");
      if (driver.file_path) {
        formData.append("file_path", driver.file_path);
      }
      const response = await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
      if (response?.data?.statusCode === 200) {
        setDriver((prev) => ({ ...prev, mobileNo: newMobileNumber }));
        toast.success("Mobile number updated successfully!");
        return true;
      } else {
        throw new Error(response?.data?.message || "Update failed");
      }
    } catch (err) {
      console.error("Failed to update mobile number:", err);
      toast.error("Failed to update mobile number");
      throw err;
    } finally {
      setIsUpdatingMobile(false);
    }
  };

  const handlePasswordChange = async (currentPassword, newPassword) => {
    try {
      const formData = new FormData();
      formData.append("ServiceNo", driver.driverSno);
      formData.append("Name", driver.name);
      formData.append("MobileNo", driver.mobileNo);
      formData.append("role", driver.role);
      formData.append("status", driver.status);
      formData.append("password", newPassword);
      if (driver.file_path) {
        formData.append("file_path", driver.file_path);
      }
      const response = await api.post("/User/Fileupload", formData, { headers: { "Content-Type": "multipart/form-data" } });
      if (response?.data?.statusCode === 200) {
        setDriver((prev) => ({ ...prev, password: newPassword }));
        toast.success("Password changed successfully!");
        return true;
      } else {
        throw new Error(response?.data?.message || "Password change failed");
      }
    } catch (err) {
      console.error("Failed to change password:", err);
      throw err;
    }
  };

  const updateHireAssistance = (booking) => {
    if (!booking) return;
    const pickup = { lat: parseFloat(booking.slatitude), lng: parseFloat(booking.slongitude) };
    const destination = { lat: parseFloat(booking.elatitude), lng: parseFloat(booking.elongitude) };
    const distance = calculateDistance(pickup, destination);
    const eta = estimateETA(distance);
    const fare = calculateFare(distance);
    setActiveHire({
      hireId: booking.bId,
      bookingId: booking.bId,
      status: 'accepted',
      pickupLocation: pickup,
      destinationLocation: destination,
      distance: distance,
      eta: eta,
      fare: fare,
    });
    setHireStage('accepted');
    setPickupLocation(pickup);
    setDestinationLocation(destination);
  };

  const normalizeBookingStatusCode = (bookingOrValue) => {
    const raw = bookingOrValue?.BookingStatus ?? bookingOrValue;
    const v = String(raw || "").trim().toUpperCase();
    const hasScheduleTimes = Boolean(bookingOrValue?.bsTime && bookingOrValue?.beTime);
    const isScheduledLabel = v === "S" || v === "SHEDULE BOOKING" || v === "SCHEDULE BOOKING";
    if (isScheduledLabel) return "S";
    if (hasScheduleTimes) return "S";
    return "R";
  };

  const normalizeStatus = (value) => String(value || "").trim().toUpperCase();
  const isPendingStatus = (value) => {
    const s = normalizeStatus(value);
    return s === "P" || s === "PENDING" || s === "R";
  };

  const isScheduledBookingStatus = (value) => {
    const v = normalizeStatus(value);
    return v === "S" || v === "SHEDULE BOOKING" || v === "SCHEDULE BOOKING";
  };

  const isScheduledCandidate = (booking) => {
    if (isScheduledBookingStatus(booking?.BookingStatus)) return true;
    const bookingDT = parseBookingDateTime(booking?.bookingDT);
    const bsTime = parseBookingDateTime(booking?.bsTime);
    if (!bookingDT || !bsTime) return false;
    return isPendingStatus(booking?.status) && bookingDT.getTime() !== bsTime.getTime();
  };

  const parseBookingDateTime = (dateStr) => {
    if (!dateStr) return null;
    const direct = new Date(dateStr);
    if (!isNaN(direct.getTime())) return direct;
    const parts = String(dateStr).trim().split(" ");
    if (parts.length >= 2 && parts[0].includes("/")) {
      const dateParts = parts[0].split("/");
      if (dateParts.length === 3) {
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const timePart = parts.slice(1).join(" ");
        const timeMatch = timePart.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?/i);
        if (timeMatch) {
          let hour = parseInt(timeMatch[1], 10);
          const minute = parseInt(timeMatch[2], 10);
          const second = parseInt(timeMatch[3] || "0", 10);
          const ampm = (timeMatch[4] || "").toUpperCase();
          if (ampm === "PM" && hour < 12) hour += 12;
          if (ampm === "AM" && hour === 12) hour = 0;
          return new Date(year, month - 1, day, hour, minute, second);
        }
      }
    }
    return null;
  };

  // Function to fetch reqId from API
  const fetchReqIdByBookingId = async (bId) => {
    try {
      const response = await api.get(`/BookingRegister/GetBookingById/${bId}`);
      if (response.data && response.data.reqId) {
        return response.data.reqId;
      }
      return null;
    } catch (err) {
      console.error("Failed to fetch reqId:", err);
      return null;
    }
  };

  const handleAcceptBooking = async () => {
    if (!incomingBooking || isProcessing) return;
    setIsProcessing(true);

    try {
      // Try to get reqId - first from booking, then from API
      let reqIdValue = incomingBooking.reqId || incomingBooking.ReqId || incomingBooking.requestId || "";

      // If reqId is still empty, fetch it from the API using bId
      // if (!reqIdValue && incomingBooking.bId) {
      //   console.log("Fetching reqId from API for booking:", incomingBooking.bId);
      //   reqIdValue = await fetchReqIdByBookingId(incomingBooking.bId);
      //   console.log("Fetched reqId:", reqIdValue);
      // }

      // if (!reqIdValue) {
      //   console.error("CRITICAL: reqId missing from incoming booking and could not be fetched");
      //   toast.error("Cannot accept: Missing booking reference");
      //   setIsProcessing(false);
      //   return;
      // }

      updateHireAssistance(incomingBooking);

      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10);
      const timeStr = now.toTimeString().slice(0, 8);
      const bsTimeFormatted = `${isoDate} ${timeStr}`;

      const payload = [{ status: "A", bId: incomingBooking.bId }];

      await api.post("/BookingRegister/PostBookingStatus", payload);

      const RequestStatuspayload = [{ status: "A", bId: incomingBooking.bId, reqId: reqIdValue }];

      await api.post("/BookingRegister/PostBookingRequestStatus", RequestStatuspayload);

      // Send through all WebSocket channels
      bookingWS.sendStatusUpdate({
        bId: parseInt(incomingBooking.bId),
        reqId: reqIdValue,
        status: "A",
        vId: incomingBooking.vId,
        dSNo: incomingBooking.dSNo,
        bookingSno: incomingBooking.bookingSno,
        dlatitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
        dlongitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
      });

      chatWS.sendStatus({
        bId: incomingBooking.bId,
        reqId: reqIdValue,
        status: "A",
        message: "accepted hire look for my booking for more details",
        targetUserId: incomingBooking.bookingSno
      });

      if (signalrService && signalrService.isConnected) {
        await signalrService.sendBookingStatusUpdate({
          bId: parseInt(incomingBooking.bId),
          reqId: reqIdValue,
          status: "A",
          vId: incomingBooking.vId,
          dSNo: incomingBooking.dSNo,
          bookingSno: incomingBooking.bookingSno,
          latitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
          longitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
        });
      }

      await updateVehicleBookingStatus("B");

      locationWS.updateDriverData({
        vehicleId: incomingBooking.vId,
        vehicle_type: currentVehicle?.vehicleType || "Car",
        vehicleType: currentVehicle?.vehicleType || "Car",
        latitude: currentVehicle?.latitude || vehicleLocation.latitude,
        longitude: currentVehicle?.longitude || vehicleLocation.longitude,
        bStatus: "B",
        oStatus: "O",
        status: "A",
        reqId: reqIdValue,
      });

      if (locationWS.isReady && locationWS.isReady()) {
        locationWS.sendLocationUpdate();
      }

      toast.success("Trip Accepted! Redirecting...", { position: "top-center" });
      setIsOverlayVisible(false);
      setIncomingBooking(null);
      navigate(`/driver-trip/${incomingBooking.bId}`);

    } catch (err) {
      console.error("Accept failed:", err);
      toast.error("Failed to accept trip");
      setIsProcessing(false);
    }
  };

  //   const handleAcceptBooking = async () => {
  //   if (!incomingBooking || !incomingBooking.reqId) {
  //     toast.error("No booking selected to accept!");
  //     return;
  //   }

  //   const reqIdValue = incomingBooking.reqId; // ReqId of the booking
  //   const payload = [{
  //      status: "A",
  //      bId: incomingBooking.bId
  //   }];

  //   setIsProcessing(true); // optional: show spinner

  //   try {
  //     // 1️⃣ Send to PostRequestedstatus
  //     const response = await api.post("/BookingRegister/PostBookingStatus", payload);

  //     if (response?.data?.success) {
  //       toast.success("Booking accepted successfully!");

  //       // 2️⃣ Proceed to assign driver or next stage
  //       // Example: call your existing assign function
  //       await assignDriverToBooking(incomingBooking); // <-- your function here

  //       // 3️⃣ Update UI
  //       setIncomingBooking(null); // remove accepted booking from queue
  //       setHasActiveBooking(true);

  //     } else {
  //       toast.error(response?.data?.message || "Failed to accept booking.");
  //     }

  //   } catch (err) {
  //     console.error("Accept booking failed:", err);
  //     toast.error("Error occurred while accepting booking.");
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };

  // `timedOut` is set by the overlay's response countdown (TC-10). The server
  // flow is identical to a manual decline — only the messaging differs.
  const handleCancelBooking = async ({ timedOut = false } = {}) => {
    if (!incomingBooking || isProcessing) return;
    setIsProcessing(true);

    try {
      let reqIdValue = incomingBooking.reqId || incomingBooking.ReqId || incomingBooking.requestId || "";

      if (!reqIdValue && incomingBooking.bId) {
        reqIdValue = await fetchReqIdByBookingId(incomingBooking.bId);
      }


      const payload = [{ status: "C", bId: incomingBooking.bId }];

      await api.post("/BookingRegister/PostBookingStatus", payload);

      const RequestStatuspayload = [{ status: "C", bId: incomingBooking.bId, reqId: reqIdValue }];

      await api.post("/BookingRegister/PostBookingRequestStatus", RequestStatuspayload);


      bookingWS.sendStatusUpdate({
        bId: parseInt(incomingBooking.bId),
        vId: incomingBooking.vId,
        reqId: reqIdValue,
        status: "C",
        dSNo: incomingBooking.dSNo,
        bookingSno: incomingBooking.bookingSno,
        dlatitude: parseFloat(incomingBooking.dlatitude) || parseFloat(incomingBooking.slatitude) || 0,
        dlongitude: parseFloat(incomingBooking.dlongitude) || parseFloat(incomingBooking.slongitude) || 0,
      });

      chatWS.sendStatus({
        bId: incomingBooking.bId,
        reqId: reqIdValue,
        status: "C",
        message: timedOut
          ? "driver did not respond in time, reassigning to another vehicle"
          : "canceled by driver check for another vehicle",
        targetUserId: incomingBooking.bookingSno
      });

      await updateVehicleBookingStatus("");
      toast.info(
        timedOut ? "No response - trip passed to another vehicle" : "Trip declined",
        { position: "top-center" }
      );

      // TC-09 — hand the rejected job to the next suitable vehicle.
      // Runs after the overlay closes so the driver is never blocked by it.
      const declinedBooking = incomingBooking;
      setIsOverlayVisible(false);
      setIncomingBooking(null);
      reassignDeclinedBooking(declinedBooking, reqIdValue);
    } catch (err) {
      console.error("Decline failed:", err);
      toast.error("Failed to decline");
    } finally {
      setIsProcessing(false);
    }
  };

  // ── TC-09: auto-reassign a declined booking to the next suitable vehicle ──
  // Reuses the same client-side ranking (AdminFindNearestDriver) and the same
  // assignment endpoint (AdminAcceptBooking) the admin flow uses, excluding
  // every vehicle already known to have rejected this booking.
  const reassignDeclinedBooking = async (booking, reqIdValue) => {
    if (!booking) return;

    const bIdKey = booking.bId;
    const declinedVehicleId = booking.vId || currentVehicle?.vehicleId;
    const excluded = addDeclinedVehicle(bIdKey, declinedVehicleId);

    // The driver-side booking object is built from WebSocket payloads and does
    // not always carry the fields the ranking function needs. Fill them in
    // defensively — without this, a missing beTime throws and the reassign
    // silently never happens, and a missing tonnage disables the capacity
    // filter entirely (extractTonnage(undefined) === 0, so anything matches).
    const bsTime = booking.bsTime || booking.bookedDate || booking.bookingDT;
    let beTime = booking.beTime;
    if (!beTime && bsTime) {
      const start = new Date(bsTime);
      if (!isNaN(start.getTime())) {
        beTime = new Date(start.getTime() + 60 * 60 * 1000).toISOString();
        console.warn("[Reassign] booking.beTime missing - assuming 1h duration");
      }
    }

    // Fall back to the declining vehicle's own capacity. It was considered
    // suitable for this job, so requiring >= that is conservative: it may skip
    // a smaller-but-adequate vehicle, but it will never under-assign.
    const tonnage = booking.tonnage || booking.weightCat || currentVehicle?.weightCat;
    if (!booking.tonnage) {
      console.warn("[Reassign] booking.tonnage missing - falling back to", tonnage);
    }

    if (!bsTime || !beTime || !tonnage) {
      console.error(
        "[Reassign] Cannot reassign - missing required fields",
        { bsTime, beTime, tonnage }
      );
      return;
    }

    try {
      const result = await dispatch(
        AdminFindNearestDriver(
          {
            ...booking,
            reqId: booking.reqId || reqIdValue,
            bsTime,
            beTime,
            tonnage,
            // AdminFindNearestDriver expects bId empty when creating a new
            // assignment record rather than editing the declined one
            bId: "",
          },
          excluded
        )
      );

      const nextVehicle = result?.nearest;
      if (!nextVehicle) {
        console.warn("[Reassign] No alternative vehicle available for booking", bIdKey);
        return;
      }

      await dispatch(
        AdminAcceptBooking(
          { ...booking, reqId: booking.reqId || reqIdValue, bsTime, beTime, bId: "" },
          nextVehicle,
          authKey
        )
      );

      console.log(
        `[Reassign] Booking ${bIdKey} reassigned to vehicle ${nextVehicle.vehicleId}`,
        `(excluded: ${excluded.join(", ")})`
      );
    } catch (err) {
      // No suitable vehicle, or the assignment call failed. The booking stays
      // declined/unassigned for the admin to handle — same as before this fix.
      console.error("[Reassign] Could not reassign declined booking:", err.message);
    }
  };

  useEffect(() => {
    if (!authKey) return;
    fetchDriverAndVehicle();
    fetchWeatherAlert();
  }, [authKey]);

  useEffect(() => {
    incomingBookingRef.current = incomingBooking;
  }, [incomingBooking]);

  useEffect(() => {
    if (!authKey || !currentVehicle?.vehicleId || !userDetails?.ServiceNo) {
      setHasActiveBooking(false);
      return;
    }

    let isMounted = true;
    const pollActiveBooking = async () => {
      try {
        const driverId = String(userDetails.ServiceNo || "").trim();
        const vehicleId = String(currentVehicle.vehicleId || "").trim();
        const allBookings = await getBookings();
        const active = (allBookings || []).some((b) => {
          return (
            String(b?.dSNo || "").trim() === driverId &&
            String(b?.vId || "").trim() === vehicleId &&
            isActiveBookingStatus(b?.status)
          );
        });
        if (isMounted) setHasActiveBooking(active);
        if (!active && (currentVehicle?.bStatus === "B" || currentVehicle?.bStatus === "Booking")) {
          await updateVehicleBookingStatus("");
          if (isMounted) setCurrentVehicle({ ...currentVehicle, bStatus: "" });
        }
      } catch (err) {
        console.error("Failed to sync active booking status:", err);
      }
    };
    pollActiveBooking();
    const interval = setInterval(pollActiveBooking, 30000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [authKey, currentVehicle?.vehicleId, currentVehicle?.bStatus, userDetails?.ServiceNo]);

  // useEffect(() => {
  //   if (!isOnline || !authKey || !currentVehicle?.vehicleId || !userDetails?.ServiceNo) return;
  //   let isMounted = true;
  //   const windowMs = 2 * 60 * 1000;
  //   const pollScheduled = async () => {
  //     if (!isMounted || isOverlayVisible || isProcessing) return;
  //     try {
  //       const vehicleId = String(currentVehicle.vehicleId || "").trim();
  //       const driverId = String(userDetails.ServiceNo || "").trim();
  //       if (!vehicleId || !driverId) return;
  //       const bookings = await getBookingDetailsByVehicleId(vehicleId);
  //       const now = new Date();
  //       const due = (bookings || [])
  //         .filter((b) => String(b?.dSNo || "").trim() === driverId)
  //         .filter((b) => String(b?.vId || "").trim() === vehicleId)
  //         .filter((b) => isScheduledCandidate(b))
  //         .filter((b) => isPendingStatus(b?.status))
  //         .filter((b) => b?.bsTime);
  //       const sorted = due.sort((a, b) => {
  //         const aTime = parseBookingDateTime(a.bsTime)?.getTime() || 0;
  //         const bTime = parseBookingDateTime(b.bsTime)?.getTime() || 0;
  //         return aTime - bTime;
  //       });
  //       for (const booking of sorted) {
  //         const bId = booking?.bId;
  //         if (!bId) continue;
  //         const key = String(bId);
  //         if (scheduledShownRef.current.has(key)) continue;
  //         const startTime = parseBookingDateTime(booking.bsTime);
  //         if (!startTime) continue;
  //         const diff = now.getTime() - startTime.getTime();
  //         if (diff >= 0 && diff <= windowMs) {
  //           const scheduledBooking = { ...booking, BookingStatus: normalizeBookingStatusCode(booking) };
  //           setIncomingBooking(scheduledBooking);
  //           setIsOverlayVisible(true);
  //           scheduledShownRef.current.add(key);
  //           toast.info("Scheduled trip time reached", { position: "top-center", autoClose: 6000 });
  //           break;
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Scheduled booking poll failed:", err);
  //     }
  //   };
  //   pollScheduled();
  //   const interval = setInterval(pollScheduled, 30000);
  //   return () => {
  //     isMounted = false;
  //     clearInterval(interval);
  //   };
  // }, [isOnline, authKey, currentVehicle?.vehicleId, userDetails?.ServiceNo, isOverlayVisible, isProcessing]);

    useEffect(() => {
    if (!isOnline || !authKey || !currentVehicle?.vehicleId || !userDetails?.ServiceNo) return;
    let isMounted = true;
    const windowMs = 10 * 60 * 1000;
    const pollScheduled = async () => {
      if (!isMounted || isOverlayVisible || isProcessing) return;
      try {
        const vehicleId = String(currentVehicle.vehicleId || "").trim();
        const driverId = String(userDetails.ServiceNo || "").trim();
        if (!vehicleId || !driverId) return;
        const bookings = await getBookingDetailsByVehicleId(vehicleId);
        const now = new Date();
        const due = (bookings || [])
          .filter((b) => String(b?.dSNo || "").trim() === driverId)
          .filter((b) => String(b?.vId || "").trim() === vehicleId)
          .filter((b) => isScheduledCandidate(b))
          .filter((b) => isPendingStatus(b?.status))
          .filter((b) => b?.bsTime);
        const sorted = due.sort((a, b) => {
          const aTime = parseBookingDateTime(a.bsTime)?.getTime() || 0;
          const bTime = parseBookingDateTime(b.bsTime)?.getTime() || 0;
          return aTime - bTime;
        });
        for (const booking of sorted) {
          const bId = booking?.bId;
          if (!bId) continue;
          const key = String(bId);
          if (scheduledShownRef.current.has(key)) continue;
          const startTime = parseBookingDateTime(booking.bsTime);
          if (!startTime) continue;
          const diff = now.getTime() - startTime.getTime();
          if (diff >= 0 && diff <= windowMs) {
            const scheduledBooking = {
              ...booking,
              BookingStatus: normalizeBookingStatusCode(booking),
              dSNo: booking.dSNo || driverId,
              vId: booking.vId || vehicleId,
              bId: booking.bId,
            };
            console.log(":bell: SCHEDULED BOOKING ALERT:", scheduledBooking.bId, "at", startTime);

            // Set the booking and show overlay
            setIncomingBooking(scheduledBooking);
            setIsOverlayVisible(true);
            scheduledShownRef.current.add(key);
            toast.info(`:alarm_clock: Scheduled trip #${booking.bId} is ready!`, { position: "top-center", autoClose: 6000 });
            break;
          }
        }
      } catch (err) {
        console.error("Scheduled booking poll failed:", err);
      }
    };
    pollScheduled();
    const interval = setInterval(pollScheduled, 15000); // Check every 15 seconds instead of 30
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [isOnline, authKey, currentVehicle?.vehicleId, userDetails?.ServiceNo, isOverlayVisible, isProcessing]);
  
  useEffect(() => {
    if (!isOnline || !authKey || !currentVehicle || !userDetails?.ServiceNo) {
      signalrService.disconnect();
      bookingWS.disconnect();
      clearInterval(locationInterval.current);
      return;
    }

    signalrService.connect(authKey, userDetails.ServiceNo);
    bookingWS.connect(authKey, userDetails.ServiceNo, currentVehicle.vehicleId);
    chatWS.connect(authKey, userDetails.ServiceNo, "Driver");

    // const processIncomingBooking = async (booking) => {
    //   // Preserve reqId from original booking, if not present, fetch it
    //   let reqIdValue = booking.reqId || booking.ReqId || booking.requestId || booking.bookingReqId;

    //   // If reqId is missing, fetch it from API
    //   if (!reqIdValue && booking.bId) {
    //     reqIdValue = await fetchReqIdByBookingId(booking.bId);
    //   }

    //   const bIdIsValid = booking.bId && !String(booking.bId).startsWith("TEMP") && !isNaN(parseInt(booking.bId));

    //   if (bIdIsValid) {
    //     if (booking.dSNo && userDetails?.ServiceNo && booking.dSNo.toString() === userDetails.ServiceNo.toString()) {
    //       const bookingWithReqId = {
    //         ...booking,
    //         reqId: reqIdValue,
    //         ReqId: reqIdValue,
    //         requestId: reqIdValue,
    //       };
    //       setIncomingBooking(bookingWithReqId);
    //       setIsOverlayVisible(true);
    //       toast.info(`New Trip Request #${booking.bId}`, { position: "top-center", autoClose: 6000 });
    //     }
    //   } else {
    //     try {
    //       let latestPendingBooking = null;
    //       if (booking?.vId) {
    //         const byVehicle = await getBookingDetailsByVehicleId(booking.vId);
    //         latestPendingBooking = (byVehicle || [])
    //           .filter(b => String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
    //             (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
    //           .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
    //       }
    //       if (!latestPendingBooking) {
    //         const allBookings = await getBookings();
    //         latestPendingBooking = (allBookings || [])
    //           .filter(b => String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
    //             (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
    //           .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
    //       }
    //       if (!latestPendingBooking) {
    //         const forkBookings = await getForkBookingDetailsAll();
    //         latestPendingBooking = (forkBookings || [])
    //           .filter(b => String(b?.vId || "").trim() === String(booking?.vId || "").trim() &&
    //             String(b?.dSNo || "").trim() === String(userDetails.ServiceNo || "").trim() &&
    //             (String(b?.status || "").trim().toUpperCase() === "P" || String(b?.status || "").trim().toUpperCase() === "PENDING"))
    //           .sort((a, b) => new Date(b.bookingDT) - new Date(a.bookingDT))[0] || null;
    //       }
    //       if (latestPendingBooking) {
    //         const actualBooking = {
    //           ...booking,
    //           ...latestPendingBooking,
    //           reqId: reqIdValue,
    //           ReqId: reqIdValue,
    //           requestId: reqIdValue,
    //           bId: latestPendingBooking.bId,
    //           vehicle_id: latestPendingBooking.vehicle_id || latestPendingBooking.vId || 0,
    //         };
    //         setIncomingBooking(actualBooking);
    //         setIsOverlayVisible(true);
    //         toast.info(`New Trip Request #${actualBooking.bId}`, { position: "top-center", autoClose: 6000 });
    //       } else {
    //         const fallbackBooking = {
    //           ...booking,
    //           reqId: reqIdValue,
    //           ReqId: reqIdValue,
    //           requestId: reqIdValue,
    //           vehicle_id: booking.vehicle_id || booking.vId || 0,
    //         };
    //         setIncomingBooking(fallbackBooking);
    //         setIsOverlayVisible(true);
    //         toast.warning("Booking notification received but limited details available", { position: "top-center" });
    //       }
    //     } catch (err) {
    //       console.error("Failed to fetch booking:", err);
    //       const fallbackBooking = { ...booking, reqId: reqIdValue, ReqId: reqIdValue, requestId: reqIdValue };
    //       setIncomingBooking(fallbackBooking);
    //       setIsOverlayVisible(true);
    //       toast.info(`New Trip Request`, { position: "top-center", autoClose: 6000 });
    //     }
    //   }
    // };

    const processIncomingBooking = async (booking) => { 
      if (!booking) {
        console.warn("⚠️ Received empty booking object");
        return;
      }

      // Validate bId - must exist and be valid
      const bId = booking.bId;
      const isValidBId = bId &&
        !String(bId).startsWith("TEMP") &&
        !String(bId).startsWith("null") &&
        !String(bId).startsWith("undefined") &&
        !isNaN(parseInt(bId)) &&
        parseInt(bId) > 0;

      if (!isValidBId) {
        console.warn("⚠️ Invalid or missing bId in booking:", bId);
        return; // Don't show alert for invalid bId
      }

      // Validate dSNo (driver service number) - must exist and be valid
      const dSNo = booking.dSNo || booking.DSNo;
      const isValidDSNo = dSNo &&
        String(dSNo).trim() !== "" &&
        String(dSNo).trim() !== "null" &&
        String(dSNo).trim() !== "undefined" &&
        !isNaN(parseInt(dSNo)) &&
        parseInt(dSNo) > 0;

      if (!isValidDSNo) {
        console.warn("⚠️ Invalid or missing dSNo in booking:", dSNo);
        return; // Don't show alert for invalid driver ID
      }

      // Get current logged-in driver's ServiceNo
      const currentDriverSno = userDetails?.ServiceNo;
      if (!currentDriverSno) {
        console.warn("⚠️ Current driver ServiceNo not found");
        return;
      }

      // STRICT CHECK: Only show alert if dSNo EXACTLY matches current driver
      const bookingDriverId = String(dSNo).trim();
      const currentDriverId = String(currentDriverSno).trim();

      if (bookingDriverId !== currentDriverId) {
        console.log(`❌ Booking not for this driver. Booking driver: ${bookingDriverId}, Current driver: ${currentDriverId}`);
        return; // Don't show alert for other drivers
      }

      console.log(`✅ Valid booking for driver ${currentDriverId}, Booking ID: ${bId}`);

      let reqIdValue = booking.reqId || booking.ReqId || booking.requestId || booking.bookingReqId;
      const subBookValue = booking.SubBook || "";

      // If reqId is missing, fetch it from API
      // if (!reqIdValue && bId) {
      //   console.log("Fetching reqId from API for booking:", bId);
      //   try {
      //     reqIdValue = await fetchReqIdByBookingId(bId);
      //     console.log("Fetched reqId:", reqIdValue);
      //   } catch (err) {
      //     console.error("Failed to fetch reqId:", err);
      //     // Still proceed with the booking even if reqId fetch fails
      //   }
      // }

      // Create booking object with reqId

      const bookingWithReqId = {
        ...booking,
        bId: parseInt(bId),
        reqId: reqIdValue,
        ReqId: reqIdValue,
        requestId: reqIdValue,
        SubBook: subBookValue, 
        subBook: subBookValue,
        dSNo: bookingDriverId, 
        resourceCode: subBookValue,
      };

      setIncomingBooking(bookingWithReqId);
      setIsOverlayVisible(true);
      toast.info(`New Trip Request #${bId}`, {
        position: "top-center",
        autoClose: 6000
      });
    };

    // signalrService.onNewBooking((booking) => {
    //   if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
    //     const currentBooking = incomingBookingRef.current;
    //     if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
    //       incomingBookingRef.current = null;
    //       setIncomingBooking(null);
    //       setIsOverlayVisible(false);
    //       toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
    //     }
    //     return;
    //   }
    //   processIncomingBooking(booking);
    // });

    signalrService.onNewBooking((booking) => {
      console.log("📡 SignalR received:", booking);

      // Handle cancellation
      if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
        const currentBooking = incomingBookingRef.current;
        if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
          incomingBookingRef.current = null;
          setIncomingBooking(null);
          setIsOverlayVisible(false);
          toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
        }
        return;
      }

      // VALIDATE before processing
      if (!booking?.bId || !booking?.dSNo) {
        console.warn("⚠️ SignalR received incomplete booking:", booking);
        return; // Ignore incomplete bookings
      }

      processIncomingBooking(booking);
    });

    bookingWS.onNewBooking((booking) => {
      console.log("🔌 BookingWS received:", booking);

      // Handle cancellation
      if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
        const currentBooking = incomingBookingRef.current;
        if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
          incomingBookingRef.current = null;
          setIncomingBooking(null);
          setIsOverlayVisible(false);
          toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
        }
        return;
      }

      // VALIDATE before processing
      if (!booking?.bId || !booking?.dSNo) {
        console.warn("⚠️ BookingWS received incomplete booking:", booking);
        return; // Ignore incomplete bookings
      }

      processIncomingBooking(booking);
    });

    bookingWS.onNewBooking((booking) => {
      if (booking.type === "booking_cancelled" || booking.action === "booking_cancelled") {
        const currentBooking = incomingBookingRef.current;
        if (currentBooking && String(booking.bId) === String(currentBooking.bId)) {
          incomingBookingRef.current = null;
          setIncomingBooking(null);
          setIsOverlayVisible(false);
          toast.error("🚫 Booking cancelled by employee", { position: "top-center", autoClose: 4000 });
        }
        return;
      }
      processIncomingBooking(booking);
    });

    if (locationInterval.current) clearInterval(locationInterval.current);
    locationInterval.current = setInterval(() => {
      updateVehicleLocation();
    }, 30000);

    return () => {
      signalrService.disconnect();
      bookingWS.disconnect();
      if (locationInterval.current) clearInterval(locationInterval.current);
    };
  }, [isOnline, authKey, currentVehicle, userDetails?.ServiceNo]);

  useEffect(() => {
    const timer = setTimeout(fetchWeatherAlert, 5000);
    return () => clearTimeout(timer);
  }, [vehicleLocation]);

  useEffect(() => {
    if (isOnline && locationWS.isReady()) {
      locationWS.updateDriverData({
        latitude: vehicleLocation.latitude,
        longitude: vehicleLocation.longitude,
      });
    }
  }, [vehicleLocation, isOnline]);

  if (!authKey) {
    return <div className="text-center py-20 text-xl">Please log in</div>;
  }

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
      <DriverHeader driver={driver} isOnline={isOnline} toggleOnline={toggleOnlineStatus} />

      <main className="flex-1 px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8 max-w-7xl mx-auto w-full space-y-4 sm:space-y-6 md:space-y-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
          <div className="bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow flex items-center gap-2 sm:gap-3 md:gap-4">
            <div className="flex flex-1 flex-row items-center gap-2 sm:gap-3 md:gap-4">
              <div className="relative flex-shrink-0">
                <img
                  src={driver.profilePic}
                  alt="Profile"
                  onClick={() => setIsProfileDetailsVisible(true)}
                  className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full border-4 border-blue-300 object-cover cursor-pointer hover:border-blue-500 transition-all"
                  onError={(e) => { e.target.src = defaultUserImg; }}
                />
                <button
                  onClick={() => fileInputRef.current?.click()}
                  disabled={isUploadingPic}
                  className="absolute bottom-0 right-0 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-1 sm:p-1.5 shadow-lg transition disabled:bg-gray-400"
                >
                  {isUploadingPic ? (
                    <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-4 md:h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  )}
                </button>
                <input ref={fileInputRef} type="file" accept="image/*" onChange={handleProfilePictureChange} className="hidden" />
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-sm sm:text-base md:text-xl lg:text-2xl font-bold text-blue-900 truncate">{driver.name}</h2>
                <div className="text-[10px] sm:text-xs md:text-sm text-gray-700 space-y-0.5 sm:space-y-1">
                  <p className="truncate"><strong>ID:</strong> {driver.driverSno}</p>
                  {driver.vehicleId ? (
                    <div className="flex items-center gap-2 bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-200 rounded-lg px-3 py-2 mt-1">
                      <div className="flex-1 min-w-0">
                        <p className="text-[10px] sm:text-xs font-semibold text-indigo-900 truncate">{driver.vehicleId}</p>
                        <p className="text-[9px] sm:text-[10px] text-indigo-600">{driver.vehicleType || 'Unknown'}</p>
                        <p className="text-[9px] sm:text-[10px] text-orange-600 font-semibold">
                          Weight: {driver.weightCat || '-'}
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <img src={getVehicleIcon(driver.vehicleType)} alt={`${driver.vehicleType} icon`} className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
                      </div>
                    </div>
                  ) : (
                    <p className="truncate text-gray-500 italic"><strong>Vehicle:</strong> No Vehicle Assigned Yet</p>
                  )}
                  <p className="truncate"><strong>Mobile:</strong> {driver.mobileNo}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center flex-shrink-0">
              <span className={`mb-2 sm:mb-3 text-[11px] sm:text-sm font-semibold px-3 py-1 rounded-full animate-pulse ${isOnline ? "bg-green-100 text-green-800" : "bg-gray-200 text-gray-700"}`}>
                {isOnline ? "You are now online" : "You are now offline"}
              </span>
              <button
                onClick={toggleOnlineStatus}
                disabled={isUpdatingStatus || !driver.vehicleId}
                className={`px-3 sm:px-6 md:px-8 lg:px-12 py-2 sm:py-3 md:py-4 lg:py-5 rounded-lg sm:rounded-xl md:rounded-2xl font-bold text-[10px] sm:text-sm md:text-base lg:text-xl transition-all transform shadow-lg whitespace-nowrap ${!driver.vehicleId ? "bg-gray-400 cursor-not-allowed opacity-60" : isOnline ? "bg-red-600 hover:bg-red-700 hover:scale-105" : "bg-green-600 hover:bg-green-700 hover:scale-105"} text-white ${isUpdatingStatus ? "opacity-70 cursor-not-allowed" : ""}`}
              >
                {isUpdatingStatus ? "Updating..." : isOnline ? "GO OFFLINE" : "GO ONLINE"}
              </button>
              {!driver.vehicleId && (
                <p className="mt-2 text-xs sm:text-sm font-semibold text-red-600 bg-red-50 px-3 py-1 rounded-lg border border-red-200 animate-pulse">⚠️ Vehicle Not Assigned Yet</p>
              )}
              {isOnline && hasActiveBooking && (
                <p className="mt-2 text-[10px] sm:text-xs md:text-sm font-semibold text-red-600 bg-red-50 px-2 py-1 rounded-lg border border-red-200 animate-pulse text-center max-w-[180px] sm:max-w-none">⚠️ Cannot go offline during active hire</p>
              )}
              <button onClick={() => navigate("/driver/scheduled-bookings")} className="mt-3 px-3 sm:px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] sm:text-xs md:text-sm font-semibold shadow transition-all">View Scheduled Bookings</button>
            </div>
          </div>

          <div className="bg-gradient-to-r from-amber-50 to-orange-100 p-4 sm:p-5 md:p-6 rounded-xl shadow-lg border border-amber-200">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="text-2xl sm:text-3xl md:text-4xl">🌤️</div>
              <div className="flex-1">
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-amber-900">Weather Alert</h3>
                <p className="text-xs sm:text-sm md:text-base text-amber-800 font-medium">{weatherAlert}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden" style={{ position: "relative", zIndex: "auto" }}>
          <div className="bg-blue-900 text-white p-3 sm:p-4">
            <h2 className="text-base sm:text-lg md:text-xl font-bold">Live Vehicle Location</h2>
          </div>
          <div style={{ height: "300px", zIndex: 1 }} className="sm:h-96 md:h-[500px]">
            <style>{`.leaflet-container { z-index: 1 !important; } .leaflet-popup { z-index: 2 !important; } .leaflet-control { z-index: 2 !important; }`}</style>
            <MapContainer center={[vehicleLocation.latitude, vehicleLocation.longitude]} zoom={17} style={{ height: "100%", width: "100%", zIndex: 1 }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <RecenterButton position={[vehicleLocation.latitude, vehicleLocation.longitude]} zoom={16} />
              <AnimatedMapCenter position={[vehicleLocation.latitude, vehicleLocation.longitude]} />
              {hasLocationFix && (
                <CircleMarker center={[vehicleLocation.latitude, vehicleLocation.longitude]} radius={14} fillColor="#2563eb" color="#1d4ed8" weight={6} opacity={1} fillOpacity={0.9}>
                  <Popup>
                    <strong className="text-xs sm:text-sm">{driver.vehicleId}</strong><br className="hidden sm:block" />
                    <span className="text-xs sm:text-sm">{driver.vehicleType}</span><br className="hidden sm:block" />
                    <span className="text-xs sm:text-sm">Weight: {driver.weightCat || "-"}</span><br className="hidden sm:block" />
                    <span className="text-xs sm:text-sm">Driver: {driver.name}</span>
                  </Popup>
                </CircleMarker>
              )}
            </MapContainer>
          </div>
        </div>

        <ActiveBookingsPanel driverSno={driver.driverSno} isOnline={isOnline} />
      </main>

      <BookingAlertOverlay
        isProcessing={isProcessing}
        booking={incomingBooking}
        isVisible={isOverlayVisible}
        onAccept={handleAcceptBooking}
        onCancel={() => handleCancelBooking()}
        onTimeout={() => handleCancelBooking({ timedOut: true })}
      />

      <UserDetailsOverlay
        isVisible={isProfileDetailsVisible}
        onClose={() => setIsProfileDetailsVisible(false)}
        userDetails={driver}
        userRole="Driver"
        fileInputRef={fileInputRef}
        onProfilePictureChange={handleProfilePictureChange}
        isUploadingPic={isUploadingPic}
        onMobileNumberUpdate={handleMobileNumberUpdate}
        isUpdatingMobile={isUpdatingMobile}
        canEditMobile={true}
        onPasswordChange={handlePasswordChange}
        isUpdatingPassword={isUpdatingPassword}
        canChangePassword={true}
      />

      <ProfilePictureCropper isOpen={showCropper} onClose={handleCropperClose} onCropComplete={handleCropComplete} imageSrc={selectedImage} />
      <DriverFooter />

      <EmergencyAlertModal isOpen={isEmergencyModalOpen} onClose={() => setIsEmergencyModalOpen(false)} onSend={handleSendEmergency} isSending={isSendingEmergency} />

      <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[9999] flex flex-col items-end font-sans">
        <AnimatePresence>
          {!isSosExpanded ? (
            <motion.button initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 300, damping: 30 }} onClick={() => setIsSosExpanded(true)} className="bg-red-50 hover:bg-red-100 border-l-[3px] md:border-l-4 border-red-600 shadow-xl py-4 pl-2 pr-0.5 rounded-l-xl md:py-2 md:pl-1 md:pr-0 md:rounded-l-lg flex items-center justify-center transition-colors" title="SOS">
              <ChevronLeft className="w-5 h-5 md:w-3 md:h-3 text-red-600" />
            </motion.button>
          ) : (
            <motion.div initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 300, damping: 30 }} className="bg-white border md:border-l-4 border-red-600 shadow-2xl rounded-l-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 mr-0" style={{ maxWidth: "90vw" }}>
              <button onClick={() => setIsSosExpanded(false)} className="p-1.5 md:p-1 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-600 transition-colors flex-shrink-0">
                <ChevronRight className="w-5 h-5 md:w-3 md:h-3" />
              </button>
              <div className="flex flex-col items-center gap-1 md:gap-2 min-w-0">
                <span className="text-[10px] md:text-sm font-bold text-red-800 uppercase tracking-wider whitespace-nowrap">Emergency</span>
                <motion.button 
                  whileHover={{ scale: 1.05 }} 
                  whileTap={{ scale: 0.95 }} 
                  onClick={
                    hasActiveEmergency 
                      ? handleResolveEmergency
                      : handleOpenEmergency
                  } 
                  className="flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-red-700 text-white shadow-lg border-2 md:border-4 border-red-100 ring-2 md:ring-4 ring-red-500/20"
                >
                  <div className="flex flex-col items-center">
                    <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 mb-0.5" />
                    <span className="text-[9px] md:text-[10px] font-black">{hasActiveEmergency ? "CLEAR" : "SOS"}</span>
                  </div>
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {activeHire && (
        <HireAssistanceBubble
          hireData={activeHire}
          driverInfo={{
            name: driver.name,
            phone: driver.mobileNo,
            rating: 4.8,
            vehicleInfo: `${driver.vehicleType} • ${driver.vehicleId}`,
            profileImage: driver.profilePic,
          }}
          driverLocation={{ lat: vehicleLocation.latitude, lng: vehicleLocation.longitude }}
          onCallDriver={() => { if (driver.mobileNo) window.location.href = `tel:${driver.mobileNo}`; }}
          onMessageDriver={() => toast.info("Messaging feature coming soon!")}
          onEmergency={handleOpenEmergency}
          isLocationSharing={isOnline}
        />
      )}
    </div>
  );
};

export default DriverDashboard;
